// // src/components/pages/TiffinService.jsx

// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { getColors } from '../../styles/colors';
// import { 
//   FaClock, FaFire, FaUtensils, FaLeaf, FaTruck, 
//   FaCalendarCheck, FaArrowRight, FaTimes,
//   FaCalendarAlt, FaCheck, FaPlus, FaMinus,
//   FaCalendarWeek, FaBookmark, FaInfoCircle,
//   FaSpinner, FaFish, FaExclamationTriangle,
//   FaTrash, FaList, FaCalendarDay, FaSave, FaEraser,
//   FaChevronLeft, FaChevronRight, FaCircle, FaMapMarkerAlt,
//   FaEdit
// } from 'react-icons/fa';
// import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
// import { 
//   createSubscriptionAsync, 
//   getSubscriptionListAsync, 
//   cancelSubscriptionAsync 
// } from '../../redux/slices/subscriptionSlice';
// import { customDateApi } from '../../api/customDateApi';
// import apiService from '../../api/authApi';
// import { setShowLoginModal } from '../../redux/slices/authSlice';
// import LoginModal from '../common/LoginModal';

// const TiffinService = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const theme = useSelector((state) => state.theme.mode);
//   const isDark = theme === 'dark';
//   const colors = getColors(isDark);
  
//   // Get auth state
//   const { showLoginModal } = useSelector((state) => state.auth);
  
//   // Get subscription state
//   const { isLoading: reduxIsLoading, isSubscribing, error: subscriptionError } = useSelector((state) => state.subscription || {});
//   const [isLoading, setIsLoading] = useState(false);
  
//   // State for view mode
//   const [viewMode, setViewMode] = useState('monthly');
//   const [showModal, setShowModal] = useState(false);
  
//   // Weekly Menu State
//   const [weeklyMenu, setWeeklyMenu] = useState([]);
//   const [weeklyMenuLoading, setWeeklyMenuLoading] = useState(false);
//   const [weeklyMenuError, setWeeklyMenuError] = useState(null);
  
//   // Monthly Subscription State - With checkbox selection
//   const [subscriptionStartDate, setSubscriptionStartDate] = useState(new Date());
//   const [showCalendar, setShowCalendar] = useState(false);
//   const [deliveryAddress, setDeliveryAddress] = useState('');
//   const [duration, setDuration] = useState(30);
//   const [mealItems, setMealItems] = useState([
//     { 
//       meal_time: 'Breakfast', 
//       time_slot: '07:30 AM - 10:00 AM',
//       veg: { selected: true, quantity: 1 }, 
//       nonVeg: { selected: false, quantity: 0 }
//     },
//     { 
//       meal_time: 'Lunch', 
//       time_slot: '12:00 PM - 02:30 PM',
//       veg: { selected: true, quantity: 1 }, 
//       nonVeg: { selected: false, quantity: 0 }
//     },
//     { 
//       meal_time: 'Dinner', 
//       time_slot: '07:30 PM - 10:00 PM',
//       veg: { selected: true, quantity: 1 }, 
//       nonVeg: { selected: false, quantity: 0 }
//     }
//   ]);
  
//   // Custom Date State
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [customBookingEntries, setCustomBookingEntries] = useState([]);
//   const [customDeliveryAddress, setCustomDeliveryAddress] = useState('');
  
//   // Local error state
//   const [localError, setLocalError] = useState(null);
//   const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
//   const [refreshKey, setRefreshKey] = useState(0);
  
//   // ✅ State for date meal selection modal (Custom Date)
//   const [showDateMealModal, setShowDateMealModal] = useState(false);
//   const [selectedDateForMeal, setSelectedDateForMeal] = useState(null);
  
//   // ✅ Meal selection state for the date modal (similar to monthly but per date)
//   const [dateMealSelections, setDateMealSelections] = useState({
//     Breakfast: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
//     Lunch: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
//     Dinner: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 }
//   });

//   // Meal prices
//   const mealPrices = { Breakfast: 50, Lunch: 70, Dinner: 90 };

//   // ========== CHECK AUTHENTICATION ==========
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (!token) {
//       dispatch(setShowLoginModal(true));
//     }
//   }, [dispatch]);

//   // ========== EFFECTS ==========
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       checkExistingSubscription();
//     }
    
//     const userData = JSON.parse(localStorage.getItem('user') || '{}');
//     if (userData.address) {
//       setDeliveryAddress(userData.address);
//       setCustomDeliveryAddress(userData.address);
//       console.log('📦 Loaded address from profile:', userData.address);
//     }
//   }, [refreshKey]);

//   // ========== PREVENT SCROLLING ON HERO PAGE ==========
//   useEffect(() => {
//     // Save original overflow style
//     const originalOverflow = document.body.style.overflow;
//     const originalHtmlOverflow = document.documentElement.style.overflow;
    
//     // Disable scrolling
//     document.body.style.overflow = 'hidden';
//     document.documentElement.style.overflow = 'hidden';
    
//     // Cleanup - restore scrolling when leaving page
//     return () => {
//       document.body.style.overflow = originalOverflow || '';
//       document.documentElement.style.overflow = originalHtmlOverflow || '';
//     };
//   }, []);

//   // ========== FETCH WEEKLY MENU ==========
//   const fetchWeeklyMenu = async () => {
//     setWeeklyMenuLoading(true);
//     setWeeklyMenuError(null);
    
//     try {
//       console.log('🔄 Fetching weekly menu from API...');
//       const response = await apiService.getWeeklyMenu();
//       console.log('✅ Weekly menu response:', response);
      
//       let menuItems = [];
      
//       if (response?.data && Array.isArray(response.data)) {
//         menuItems = response.data;
//       } else if (response?.grouped) {
//         const grouped = response.grouped;
//         Object.keys(grouped).forEach(day => {
//           if (Array.isArray(grouped[day])) {
//             grouped[day].forEach(item => {
//               menuItems.push({
//                 ...item,
//                 day: day
//               });
//             });
//           }
//         });
//       } else if (response?.data && typeof response.data === 'object') {
//         const grouped = response.data;
//         Object.keys(grouped).forEach(day => {
//           if (Array.isArray(grouped[day])) {
//             grouped[day].forEach(item => {
//               menuItems.push({
//                 ...item,
//                 day: day
//               });
//             });
//           }
//         });
//       } else if (Array.isArray(response)) {
//         menuItems = response;
//       }
      
//       setWeeklyMenu(menuItems);
//       console.log(`✅ Loaded ${menuItems.length} weekly menu items`);
//     } catch (error) {
//       console.error('❌ Failed to fetch weekly menu:', error);
//       setWeeklyMenuError(error.message || 'Failed to load menu');
//       setWeeklyMenu([]);
//     } finally {
//       setWeeklyMenuLoading(false);
//     }
//   };

//   // ========== SUBSCRIPTION FUNCTIONS ==========
//   const checkExistingSubscription = async () => {
//     try {
//       const result = await dispatch(getSubscriptionListAsync()).unwrap();
//       console.log('📦 Subscription list check:', result);
      
//       if (result?.data && result.data.length > 0) {
//         const activeSubscription = result.data.find(sub => 
//           sub.status?.toLowerCase() === 'pending_payment' || 
//           sub.status?.toLowerCase() === 'active'
//         );
        
//         if (activeSubscription) {
//           setLocalError(`You already have an active subscription (ID: ${activeSubscription.id}). Cancel it first to start a new one.`);
//           setSelectedSubscriptionId(activeSubscription.id);
//         } else {
//           setLocalError(null);
//           setSelectedSubscriptionId(null);
//         }
//       } else {
//         setLocalError(null);
//         setSelectedSubscriptionId(null);
//       }
//     } catch (err) {
//       console.log('No existing subscriptions or error fetching:', err);
//       setLocalError(null);
//       setSelectedSubscriptionId(null);
//     }
//   };

//   // ========== UPDATE USER PROFILE ADDRESS ==========
//   const updateUserProfileAddress = async (address, name, phone) => {
//     try {
//       console.log('📤 Updating user profile with address:', address);
      
//       const userData = {
//         name: name,
//         phone: phone,
//         address: address
//       };
      
//       const response = await apiService.updateUserProfile(userData);
//       console.log('✅ Profile updated with address:', response);
      
//       const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
//       storedUser.address = address;
//       storedUser.name = name;
//       storedUser.phone = phone;
//       localStorage.setItem('user', JSON.stringify(storedUser));
      
//       const authUser = JSON.parse(localStorage.getItem('tiffinUserLogin') || '{}');
//       authUser.address = address;
//       authUser.name = name;
//       authUser.phone = phone;
//       localStorage.setItem('tiffinUserLogin', JSON.stringify(authUser));
      
//       window.dispatchEvent(new CustomEvent('profileUpdated', { 
//         detail: { 
//           name: name,
//           phone: phone,
//           address: address 
//         } 
//       }));
//       window.dispatchEvent(new Event('storage'));
      
//       return true;
//     } catch (error) {
//       console.error('❌ Failed to update profile address:', error);
//       return false;
//     }
//   };

//   // ========== CALENDAR FUNCTIONS ==========
//   const getDaysInMonth = (date) => {
//     const year = date.getFullYear();
//     const month = date.getMonth();
//     const daysInMonth = new Date(year, month + 1, 0).getDate();
//     const firstDay = new Date(year, month, 1).getDay();
//     return { daysInMonth, firstDay };
//   };

//   const navigateMonth = (direction) => {
//     const newDate = new Date(currentMonth);
//     newDate.setMonth(newDate.getMonth() + direction);
//     setCurrentMonth(newDate);
//   };

//   const getDateStr = (month, day) => {
//     const year = month.getFullYear();
//     const monthNum = String(month.getMonth() + 1).padStart(2, '0');
//     const dayStr = String(day).padStart(2, '0');
//     return `${year}-${monthNum}-${dayStr}`;
//   };

//   const getMealsForDate = (dateStr) => {
//     return customBookingEntries.filter(entry => entry.date === dateStr);
//   };

//   // ✅ Handle date click - OPEN MEAL SELECTION MODAL for Custom Date
//   const handleDateClick = (day) => {
//     const dateStr = getDateStr(currentMonth, day);
//     setSelectedDate(day);
//     setSelectedDateForMeal(dateStr);
    
//     // ✅ Load existing meals for this date
//     const existingMeals = customBookingEntries.filter(entry => entry.date === dateStr);
    
//     // Reset meal selections
//     const newMealSelections = {
//       Breakfast: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
//       Lunch: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
//       Dinner: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 }
//     };
    
//     // Populate existing selections
//     existingMeals.forEach(meal => {
//       const time = meal.meal_time;
//       if (meal.meal_type === 'Veg') {
//         newMealSelections[time].veg = true;
//         newMealSelections[time].vegQty = meal.quantity || 1;
//       } else if (meal.meal_type === 'Non-Veg') {
//         newMealSelections[time].nonVeg = true;
//         newMealSelections[time].nonVegQty = meal.quantity || 1;
//       }
//     });
    
//     setDateMealSelections(newMealSelections);
//     setShowDateMealModal(true);
//   };

//   // ✅ Toggle meal type for custom date
//   const toggleCustomMealType = (mealTime, type) => {
//     setDateMealSelections(prev => ({
//       ...prev,
//       [mealTime]: {
//         ...prev[mealTime],
//         [type]: !prev[mealTime][type]
//       }
//     }));
//   };

//   // ✅ Update quantity for custom date meal
//   const updateCustomMealQty = (mealTime, type, delta) => {
//     setDateMealSelections(prev => {
//       const key = type === 'veg' ? 'vegQty' : 'nonVegQty';
//       const currentQty = prev[mealTime][key];
//       const newQty = Math.max(0, currentQty + delta);
//       return {
//         ...prev,
//         [mealTime]: {
//           ...prev[mealTime],
//           [key]: newQty
//         }
//       };
//     });
//   };

//   // ✅ Save date meals for custom date
//   const handleSaveDateMeals = () => {
//     const dateStr = selectedDateForMeal;
//     if (!dateStr) return;

//     // Check if any meal is selected
//     const hasAnySelection = Object.values(dateMealSelections).some(
//       meal => meal.veg || meal.nonVeg
//     );
    
//     if (!hasAnySelection) {
//       alert('Please select at least one meal (Veg or Non-Veg) for this date.');
//       return;
//     }

//     // Remove existing entries for this date
//     const filteredEntries = customBookingEntries.filter(entry => entry.date !== dateStr);
    
//     // Add new entries
//     const newEntries = [];
//     const mealTimes = ['Breakfast', 'Lunch', 'Dinner'];
    
//     mealTimes.forEach(mealTime => {
//       const meal = dateMealSelections[mealTime];
//       if (meal.veg && meal.vegQty > 0) {
//         newEntries.push({
//           date: dateStr,
//           meal_time: mealTime,
//           meal_type: 'Veg',
//           quantity: parseInt(meal.vegQty) || 1
//         });
//       }
//       if (meal.nonVeg && meal.nonVegQty > 0) {
//         newEntries.push({
//           date: dateStr,
//           meal_time: mealTime,
//           meal_type: 'Non-Veg',
//           quantity: parseInt(meal.nonVegQty) || 1
//         });
//       }
//     });
    
//     setCustomBookingEntries([...filteredEntries, ...newEntries]);
//     setShowDateMealModal(false);
//     setSelectedDateForMeal(null);
//   };

//   // ✅ Clear all meals for the selected date
//   const handleClearDateMeals = () => {
//     const dateStr = selectedDateForMeal;
//     if (!dateStr) return;
    
//     if (!window.confirm('Are you sure you want to clear all meals for this date?')) return;
    
//     const filteredEntries = customBookingEntries.filter(entry => entry.date !== dateStr);
//     setCustomBookingEntries(filteredEntries);
//     setShowDateMealModal(false);
//     setSelectedDateForMeal(null);
//   };

//   const handleRemoveEntry = (index) => {
//     setCustomBookingEntries(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleClearAllEntries = () => {
//     if (customBookingEntries.length === 0) return;
//     if (window.confirm('Are you sure you want to clear all entries?')) {
//       setCustomBookingEntries([]);
//     }
//   };

//   // ========== CUSTOM DATE ORDER ==========
//   const handleCustomDateOrder = async () => {
//     if (customBookingEntries.length === 0) {
//       alert('Please add at least one meal entry before confirming.');
//       return;
//     }

//     if (!customDeliveryAddress.trim()) {
//       alert('Please enter your delivery address for this custom order.');
//       return;
//     }

//     setLocalError(null);
//     setIsLoading(true);

//     try {
//       const userData = JSON.parse(localStorage.getItem('user') || '{}');
//       const userName = userData.name || 'Customer';
//       const userPhone = userData.phone || '';
      
//       await updateUserProfileAddress(customDeliveryAddress.trim(), userName, userPhone);
//       console.log('✅ Profile address updated for custom order');

//       // ✅ Group items by date with correct format
//       const groupedByDate = {};
//       customBookingEntries.forEach(entry => {
//         const dateKey = entry.date;
//         if (!groupedByDate[dateKey]) {
//           groupedByDate[dateKey] = [];
//         }
//         groupedByDate[dateKey].push({
//           meal_time: entry.meal_time,
//           meal_type: entry.meal_type,
//           quantity: parseInt(entry.quantity) || 1
//         });
//       });

//       // ✅ Build bookings array
//       const bookings = Object.keys(groupedByDate).map(date => ({
//         date: date,
//         items: groupedByDate[date]
//       }));

//       const payload = {
//         bookings: bookings
//       };

//       console.log('📤 Sending custom date order payload:', JSON.stringify(payload, null, 2));
//       console.log('📅 Booking dates:', bookings.map(b => b.date));

//       const token = localStorage.getItem('token');
//       const response = await fetch('https://admin.thefoodies.in/api/tiffin/date-wise/order', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//         body: JSON.stringify(payload)
//       });

//       const responseData = await response.json();
//       console.log('📥 Response:', responseData);

//       if (response.ok && responseData.status) {
//         const orderData = responseData.data || responseData;
//         const orderId = orderData.order_id || orderData.id;
//         const orderNumber = orderData.order_number || `TIF${orderId}`;
        
//         const totalAmount = customBookingEntries.reduce((sum, entry) => {
//           const price = mealPrices[entry.meal_time] || 60;
//           return sum + (price * (parseInt(entry.quantity) || 1));
//         }, 0);
        
//         // ✅ Save to localStorage with the actual dates
//         const savedOrders = JSON.parse(localStorage.getItem('customOrders') || '[]');
        
//         const itemsWithDates = customBookingEntries.map(entry => ({
//           ...entry,
//           date: entry.date,
//           meal_time: entry.meal_time,
//           meal_type: entry.meal_type,
//           quantity: parseInt(entry.quantity) || 1,
//           price: mealPrices[entry.meal_time] || 60,
//           subtotal: (mealPrices[entry.meal_time] || 60) * (parseInt(entry.quantity) || 1)
//         }));
        
//         const newOrder = {
//           ...orderData,
//           id: orderId,
//           order_number: orderNumber,
//           order_id: orderId,
//           created_at: new Date().toISOString(),
//           date: new Date().toISOString(),
//           total: totalAmount,
//           total_amount: totalAmount,
//           items: itemsWithDates,
//           payment_status: orderData.payment_status || 'pending',
//           order_status: orderData.order_status || 'confirmed',
//           status: orderData.status || 'pending',
//           order_type: 'tiffin_date_wise',
//           delivery_address: customDeliveryAddress.trim()
//         };
//         savedOrders.unshift(newOrder);
//         localStorage.setItem('customOrders', JSON.stringify(savedOrders));
        
//         console.log('✅ Order saved with dates:', itemsWithDates.map(i => ({ date: i.date, meal: i.meal_time })));
        
//         const confirmMessage = `🎉 Custom Date Order Confirmed!\n\n` +
//           `📅 ${customBookingEntries.length} meal(s) booked\n` +
//           `💰 Total Amount: ₹${totalAmount}\n` +
//           `🧾 Order ID: ${orderNumber}\n` +
//           `📍 Delivery Address: ${customDeliveryAddress.trim()}\n\n` +
//           `📋 Order saved to My Orders!`;
        
//         alert(confirmMessage);
        
//         setCustomBookingEntries([]);
//         setShowModal(false);
//         navigate('/my-orders');
//       } else {
//         const errorMessage = responseData.message || responseData.error || 'Order placement failed';
//         console.error('❌ API Error:', responseData);
        
//         if (responseData.errors) {
//           const validationErrors = Object.values(responseData.errors).flat().join('\n');
//           throw new Error(`Validation failed:\n${validationErrors}`);
//         }
        
//         throw new Error(errorMessage);
//       }
//     } catch (error) {
//       console.error('❌ Custom date order failed:', error);
//       let errorMsg = 'Order placement failed. Please try again.';
//       if (error.response?.data?.message) {
//         errorMsg = error.response.data.message;
//       } else if (error.message) {
//         errorMsg = error.message;
//       }
//       setLocalError(errorMsg);
//       alert(`❌ ${errorMsg}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ========== MEAL ITEM FUNCTIONS (Monthly) ==========
//   const toggleVeg = (index) => {
//     setMealItems(prev => {
//       const newItems = [...prev];
//       const currentlySelected = newItems[index].veg.selected;
//       newItems[index].veg.selected = !currentlySelected;
//       if (!newItems[index].veg.selected) {
//         newItems[index].veg.quantity = 0;
//       } else {
//         newItems[index].veg.quantity = 1;
//       }
//       return newItems;
//     });
//   };

//   const toggleNonVeg = (index) => {
//     setMealItems(prev => {
//       const newItems = [...prev];
//       const currentlySelected = newItems[index].nonVeg.selected;
//       newItems[index].nonVeg.selected = !currentlySelected;
//       if (!newItems[index].nonVeg.selected) {
//         newItems[index].nonVeg.quantity = 0;
//       } else {
//         newItems[index].nonVeg.quantity = 1;
//       }
//       return newItems;
//     });
//   };

//   const updateVegQuantity = (index, delta) => {
//     setMealItems(prev => {
//       const newItems = [...prev];
//       const newQty = Math.max(0, newItems[index].veg.quantity + delta);
//       newItems[index].veg.quantity = newQty;
//       newItems[index].veg.selected = newQty > 0;
//       return newItems;
//     });
//   };

//   const updateNonVegQuantity = (index, delta) => {
//     setMealItems(prev => {
//       const newItems = [...prev];
//       const newQty = Math.max(0, newItems[index].nonVeg.quantity + delta);
//       newItems[index].nonVeg.quantity = newQty;
//       newItems[index].nonVeg.selected = newQty > 0;
//       return newItems;
//     });
//   };

//   const buildSubscriptionItems = () => {
//     const items = [];
    
//     mealItems.forEach(meal => {
//       if (meal.veg.selected && meal.veg.quantity > 0) {
//         items.push({
//           meal_time: meal.meal_time,
//           meal_type: 'Veg',
//           quantity: meal.veg.quantity
//         });
//       }
//       if (meal.nonVeg.selected && meal.nonVeg.quantity > 0) {
//         items.push({
//           meal_time: meal.meal_time,
//           meal_type: 'Non-Veg',
//           quantity: meal.nonVeg.quantity
//         });
//       }
//     });
    
//     return items;
//   };

//   const buildBookings = () => {
//     const start = new Date(subscriptionStartDate);
//     const items = buildSubscriptionItems();
//     const bookings = [];
    
//     for (let i = 0; i < duration; i++) {
//       const date = new Date(start);
//       date.setDate(date.getDate() + i);
//       const dateStr = date.toISOString().split('T')[0];
      
//       bookings.push({
//         date: dateStr,
//         items: items.map(item => ({ ...item }))
//       });
//     }
    
//     return bookings;
//   };

//   const getTotalItems = () => {
//     let count = 0;
//     mealItems.forEach(meal => {
//       if (meal.veg.selected && meal.veg.quantity > 0) count += meal.veg.quantity;
//       if (meal.nonVeg.selected && meal.nonVeg.quantity > 0) count += meal.nonVeg.quantity;
//     });
//     return count;
//   };

//   const getDailyPrice = () => {
//     let total = 0;
//     mealItems.forEach(meal => {
//       const price = mealPrices[meal.meal_time] || 60;
//       if (meal.veg.selected && meal.veg.quantity > 0) {
//         total += price * meal.veg.quantity;
//       }
//       if (meal.nonVeg.selected && meal.nonVeg.quantity > 0) {
//         total += price * meal.nonVeg.quantity;
//       }
//     });
//     return total;
//   };

//   const getTotalPrice = () => {
//     return getDailyPrice() * duration;
//   };

//   // ========== MONTHLY SUBSCRIPTION ==========
//   const handleCreateSubscription = async () => {
//     setLocalError(null);
    
//     try {
//       const items = buildSubscriptionItems();
      
//       if (items.length === 0) {
//         setLocalError('Please select at least one meal');
//         return;
//       }

//       if (!deliveryAddress.trim()) {
//         setLocalError('Please enter delivery address');
//         return;
//       }

//       const userData = JSON.parse(localStorage.getItem('user') || '{}');
//       const userName = userData.name || 'Customer';
//       const userPhone = userData.phone || '';
      
//       await updateUserProfileAddress(deliveryAddress.trim(), userName, userPhone);
//       console.log('✅ Profile address updated for monthly subscription');

//       const bookings = buildBookings();

//       const payload = {
//         start_date: subscriptionStartDate.toISOString().split('T')[0],
//         delivery_address: deliveryAddress.trim(),
//         items: items,
//         bookings: bookings
//       };
      
//       console.log('🚀 MONTHLY SUBSCRIPTION PAYLOAD:', JSON.stringify(payload, null, 2));
      
//       const result = await dispatch(createSubscriptionAsync(payload)).unwrap();
      
//       console.log('✅ Subscription created:', result);
      
//       if (result.status) {
//         const data = result.data;
        
//         const confirmMessage = `🎉 Monthly Subscription Created!\n\n` +
//           `📅 Start Date: ${data.start_date || payload.start_date}\n` +
//           `📅 End Date: ${data.end_date || 'N/A'}\n` +
//           `💰 Total: ₹${data.projected_total || getTotalPrice()}\n` +
//           `💳 Deposit (50%): ₹${data.deposit_amount || Math.round(getTotalPrice() * 0.5)}\n` +
//           `📋 Status: ${data.status || 'Pending'}\n\n` +
//           `📊 Items:\n${items.map(item => 
//             `  • ${item.meal_time} (${item.meal_type}) × ${item.quantity}`
//           ).join('\n')}\n\n` +
//           `📦 Delivery Address: ${payload.delivery_address}`;
        
//         alert(confirmMessage);
//         setShowModal(false);
//         navigate('/my-orders');
//       }
//     } catch (err) {
//       console.error('❌ Subscription failed:', err);
//       let errorMsg = 'Failed to create subscription';
//       if (typeof err === 'string') {
//         errorMsg = err;
//       } else if (err.response?.data?.message) {
//         errorMsg = err.response.data.message;
//         if (errorMsg.includes('already have an active or pending monthly subscription')) {
//           errorMsg = '⚠️ You already have an active subscription. Please cancel it first.';
//           await checkExistingSubscription();
//         }
//       } else if (err.message) {
//         errorMsg = err.message;
//       }
//       setLocalError(errorMsg);
//       alert(`❌ ${errorMsg}`);
//     }
//   };

//   // ========== CANCEL SUBSCRIPTION ==========
//   const handleCancelSubscription = async () => {
//     if (!selectedSubscriptionId) {
//       alert('No subscription found to cancel.');
//       return;
//     }
    
//     if (!window.confirm(`Are you sure you want to cancel subscription #${selectedSubscriptionId}?`)) {
//       return;
//     }
    
//     try {
//       const result = await dispatch(cancelSubscriptionAsync(selectedSubscriptionId)).unwrap();
//       console.log('✅ Subscription cancelled:', result);
//       alert('✅ Subscription cancelled successfully!');
      
//       setSelectedSubscriptionId(null);
//       setLocalError(null);
      
//       await checkExistingSubscription();
      
//       setRefreshKey(prev => prev + 1);
      
//     } catch (err) {
//       console.error('❌ Cancel subscription failed:', err);
      
//       const errorMsg = typeof err === 'string' ? err : err?.message || err?.error || '';
      
//       if (errorMsg.includes('already cancelled') || errorMsg.includes('already canceled')) {
//         alert('ℹ️ This subscription has already been cancelled.');
//         setSelectedSubscriptionId(null);
//         setLocalError(null);
//         await checkExistingSubscription();
//         setRefreshKey(prev => prev + 1);
//       } else {
//         alert('❌ Failed to cancel subscription. Please try again.');
//       }
//     }
//   };

//   // ========== UI HELPERS ==========
//   const getMealPrice = (mealTime) => {
//     return mealPrices[mealTime] || 60;
//   };

//   const getTotalCustomPrice = () => {
//     return customBookingEntries.reduce((sum, entry) => {
//       const price = mealPrices[entry.meal_time] || 60;
//       return sum + (price * entry.quantity);
//     }, 0);
//   };

//   const handleBookNow = async () => {
//     setViewMode('monthly');
//     setShowModal(true);
//     await fetchWeeklyMenu();
//   };

//   const formatDate = (date) => {
//     if (!date) return '';
//     return date.toLocaleDateString('en-US', { 
//       day: '2-digit', 
//       month: 'short', 
//       year: 'numeric' 
//     });
//   };

//   const displayError = localError || subscriptionError;

//   // ========== RENDER WEEKLY MENU ==========
//   const renderWeeklyMenuInModal = () => {
//     if (weeklyMenuLoading) {
//       return (
//         <div className="text-center py-4">
//           <FaSpinner className="animate-spin text-2xl mx-auto" style={{ color: colors.primary }} />
//           <p className="text-xs mt-1" style={{ color: colors.textSecondary }}>Loading weekly menu...</p>
//         </div>
//       );
//     }

//     if (weeklyMenuError) {
//       return (
//         <div className="text-center py-4">
//           <p className="text-xs text-red-500">{weeklyMenuError}</p>
//           <button
//             onClick={fetchWeeklyMenu}
//             className="mt-2 px-3 py-1 rounded-lg text-xs text-white transition-all hover:scale-105"
//             style={{ backgroundColor: colors.primary }}
//           >
//             Retry
//           </button>
//         </div>
//       );
//     }

//     if (!weeklyMenu || weeklyMenu.length === 0) {
//       return (
//         <div className="text-center py-4">
//           <p className="text-xs" style={{ color: colors.textSecondary }}>No weekly menu items available</p>
//         </div>
//       );
//     }

//     const groupedByDay = {};
//     weeklyMenu.forEach(item => {
//       const day = item.day || item.Day || 'Unknown';
//       if (!groupedByDay[day]) {
//         groupedByDay[day] = [];
//       }
//       groupedByDay[day].push(item);
//     });

//     const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
//     const mealTypeOrder = ['Breakfast', 'Lunch', 'Dinner'];

//     return (
//       <div className="space-y-4 max-h-80 overflow-y-auto pr-1" style={{ 
//         maxHeight: '280px',
//         scrollbarWidth: 'thin',
//         scrollbarColor: `${colors.primary} transparent`
//       }}>
//         {dayOrder.map(day => {
//           if (!groupedByDay[day] || groupedByDay[day].length === 0) return null;
          
//           return (
//             <div 
//               key={day} 
//               className="rounded-xl overflow-hidden"
//               style={{ 
//                 backgroundColor: colors.card,
//                 border: `1px solid ${colors.border}`,
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
//               }}
//             >
//               <div 
//                 className="px-4 py-2 flex items-center"
//                 style={{ 
//                   background: `linear-gradient(135deg, ${colors.primary}20, ${colors.primary}10)`,
//                   borderBottom: `1px solid ${colors.border}`
//                 }}
//               >
//                 <span className="text-sm font-bold" style={{ color: colors.primary }}>{day}</span>
//                 <span className="ml-auto text-[10px] px-2 py-0.5 rounded-full" style={{ 
//                   backgroundColor: colors.primary + '20',
//                   color: colors.primary
//                 }}>
//                   {groupedByDay[day].length} items
//                 </span>
//               </div>

//               <div className="p-3 space-y-3">
//                 {mealTypeOrder.map(mealType => {
//                   const items = groupedByDay[day].filter(item => {
//                     const time = item.available_time || item.meal_time || 'Other';
//                     return time === mealType;
//                   });
                  
//                   if (items.length === 0) return null;
                  
//                   return (
//                     <div key={mealType} className="space-y-2">
//                       <div className="flex items-center gap-2">
//                         <span className="text-sm font-semibold" style={{ color: colors.text }}>{mealType}</span>
//                       </div>
                      
//                       {['Veg', 'Non-Veg'].map(type => {
//                         const typeItems = items.filter(item => {
//                           const itemType = item.meal_type || item.type || 'Veg';
//                           return itemType === type || (type === 'Veg' && (itemType === 'Veg' || itemType === 'veg'));
//                         });
                        
//                         if (typeItems.length === 0) return null;
                        
//                         const isVeg = type === 'Veg';
                        
//                         return (
//                           <div 
//                             key={type}
//                             className="rounded-lg p-2"
//                             style={{ 
//                               backgroundColor: isVeg ? '#22C55E10' : '#EF444410',
//                               border: `1px solid ${isVeg ? '#22C55E30' : '#EF444430'}`
//                             }}
//                           >
//                             <div className="flex items-center gap-1.5 mb-1.5">
//                               <FaCircle className="text-[8px]" style={{ color: isVeg ? '#22C55E' : '#EF4444' }} />
//                               <span className="text-xs font-medium" style={{ color: isVeg ? '#22C55E' : '#EF4444' }}>
//                                 {type}
//                               </span>
//                             </div>
                            
//                             <div className="space-y-1">
//                               {typeItems.map((item, idx) => {
//                                 const foodName = item.food_name || item.name || 'Menu Item';
//                                 const price = item.price || item.amount || 0;
//                                 const availableFood = item.available_food || '';
//                                 const foodItems = availableFood ? availableFood.split('.').filter(f => f.trim()) : [];
                                
//                                 return (
//                                   <div
//                                     key={idx}
//                                     className="px-2 py-1.5 rounded cursor-pointer hover:shadow-sm transition-all"
//                                     style={{ 
//                                       backgroundColor: isVeg ? '#22C55E08' : '#EF444408',
//                                       border: `1px solid ${isVeg ? '#22C55E15' : '#EF444415'}`
//                                     }}
//                                     onClick={() => {
//                                       alert(`🍽️ ${foodName}\n💰 ₹${price}\n🥗 ${type}\n📅 ${day}\n⏰ ${mealType}\n\n📋 Menu:\n${foodItems.map((f, i) => `  ${i+1}. ${f.trim()}`).join('\n')}`);
//                                     }}
//                                   >
//                                     <div className="flex items-center justify-between">
//                                       <div className="flex-1 min-w-0">
//                                         <span className="text-xs font-medium truncate block" style={{ color: colors.text }}>
//                                           {foodName}
//                                         </span>
//                                         {foodItems.length > 0 && (
//                                           <div className="text-[10px] truncate block" style={{ color: colors.textSecondary }}>
//                                             {foodItems.map((f, i) => (
//                                               <span key={i}>
//                                                 {i > 0 && ', '}{f.trim()}
//                                               </span>
//                                             ))}
//                                           </div>
//                                         )}
//                                       </div>
//                                       <span className="text-xs font-bold flex-shrink-0 ml-2" style={{ color: colors.primary }}>
//                                         ₹{price}
//                                       </span>
//                                     </div>
//                                   </div>
//                                 );
//                               })}
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           );
//         })}
        
//         <div className="text-center text-[10px] py-1" style={{ color: colors.textSecondary }}>
//           {weeklyMenu.length} items total • {Object.keys(groupedByDay).length} days
//         </div>
//       </div>
//     );
//   };

//   // ========== RENDER CALENDAR (Custom Date) ==========
//   const renderCalendar = () => {
//     const { daysInMonth, firstDay } = getDaysInMonth(currentMonth);
//     const monthName = currentMonth.toLocaleString('default', { month: 'long' });
//     const year = currentMonth.getFullYear();

//     const days = [];
    
//     for (let i = 0; i < firstDay; i++) {
//       days.push(<div key={`empty-${i}`} className="w-12 h-12" />);
//     }

//     for (let day = 1; day <= daysInMonth; day++) {
//       const dateStr = getDateStr(currentMonth, day);
//       const hasMeal = customBookingEntries.some(entry => entry.date === dateStr);
//       const isToday = day === new Date().getDate() && 
//                      currentMonth.getMonth() === new Date().getMonth() &&
//                      currentMonth.getFullYear() === new Date().getFullYear();
      
//       days.push(
//         <button
//           key={day}
//           className={`w-12 h-12 rounded-xl text-sm font-medium transition-all hover:scale-105 relative ${
//             hasMeal ? 'border-2' : ''
//           } ${isToday ? 'ring-2 ring-offset-2' : ''}`}
//           style={{
//             backgroundColor: hasMeal ? colors.primary : 'transparent',
//             color: hasMeal ? '#FFFFFF' : colors.text,
//             borderColor: hasMeal ? colors.primary : colors.border,
//             ...(isToday && { ringColor: colors.primary })
//           }}
//           onClick={() => handleDateClick(day)}
//         >
//           {day}
//           {hasMeal && (
//             <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-green-500 border-2 border-white dark:border-gray-800" />
//           )}
//         </button>
//       );
//     }

//     return (
//       <div className="space-y-4">
//         <div className="flex items-center justify-between">
//           <h3 className="text-lg font-bold" style={{ color: colors.text }}>
//             {monthName} {year}
//           </h3>
//           <div className="flex gap-2">
//             <button
//               onClick={() => navigateMonth(-1)}
//               className="p-2 rounded-full transition-all hover:scale-110"
//               style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}
//             >
//               <FaChevronLeft style={{ color: colors.text }} />
//             </button>
//             <button
//               onClick={() => navigateMonth(1)}
//               className="p-2 rounded-full transition-all hover:scale-110"
//               style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}
//             >
//               <FaChevronRight style={{ color: colors.text }} />
//             </button>
//           </div>
//         </div>

//         <div className="grid grid-cols-7 gap-1">
//           {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
//             <div key={day} className="text-center text-xs font-medium py-1" style={{ color: colors.textSecondary }}>
//               {day}
//             </div>
//           ))}
//         </div>

//         <div className="grid grid-cols-7 gap-1">
//           {days}
//         </div>

//         <div className="flex items-center gap-4 pt-2 border-t" style={{ borderColor: colors.border }}>
//           <div className="flex items-center gap-1 text-xs" style={{ color: colors.textSecondary }}>
//             <div className="w-3 h-3 rounded-full" style={{ backgroundColor: colors.primary }} />
//             Selected
//           </div>
//           <div className="flex items-center gap-1 text-xs" style={{ color: colors.textSecondary }}>
//             <div className="w-3 h-3 rounded-full bg-green-500" />
//             Has Meal
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ========== DATE MEAL SELECTION MODAL (Custom Date) ==========
//   const DateMealModal = () => {
//     if (!showDateMealModal || !selectedDateForMeal) return null;

//     const dateObj = new Date(selectedDateForMeal);
//     const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'long' });
//     const monthName = dateObj.toLocaleDateString('en-US', { month: 'long' });
//     const dayNum = dateObj.getDate();
//     const mealTimes = ['Breakfast', 'Lunch', 'Dinner'];

//     return (
//       <div 
//         className="fixed inset-0 z-50 flex items-center justify-center px-4"
//         style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
//         onClick={() => setShowDateMealModal(false)}
//       >
//         <div
//           className="rounded-2xl p-6 max-w-md w-full max-h-[90vh] overflow-y-auto"
//           style={{ 
//             backgroundColor: colors.card,
//             border: `1px solid ${colors.border}`
//           }}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="flex items-center justify-between mb-4">
//             <div>
//               <h3 className="text-xl font-bold" style={{ color: colors.text }}>
//                 {dayName}, {dayNum} {monthName}
//               </h3>
//               <p className="text-sm" style={{ color: colors.textSecondary }}>
//                 Select meals for this date
//               </p>
//             </div>
//             <button 
//               className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
//               style={{ backgroundColor: colors.inputBackground }}
//               onClick={() => setShowDateMealModal(false)}
//             >
//               <FaTimes style={{ color: colors.text }} />
//             </button>
//           </div>

//           <div className="space-y-4">
//             {mealTimes.map(mealTime => {
//               const meal = dateMealSelections[mealTime];
//               const hasSelection = meal.veg || meal.nonVeg;
//               const price = mealPrices[mealTime] || 60;
              
//               return (
//                 <div 
//                   key={mealTime}
//                   className="rounded-xl p-4"
//                   style={{ 
//                     backgroundColor: colors.inputBackground,
//                     border: `1px solid ${colors.border}`
//                   }}
//                 >
//                   <div className="flex items-center justify-between mb-3">
//                     <div>
//                       <h4 className="font-bold text-base" style={{ color: colors.text }}>{mealTime}</h4>
//                       <p className="text-xs" style={{ color: colors.textSecondary }}>
//                         <FaClock className="inline mr-1 text-[10px]" /> 
//                         {mealTime === 'Breakfast' ? '07:30 AM - 10:00 AM' : 
//                          mealTime === 'Lunch' ? '12:00 PM - 02:30 PM' : 
//                          '07:30 PM - 10:00 PM'}
//                       </p>
//                     </div>
//                     <div className="text-xs px-2 py-0.5 rounded-full" style={{ 
//                       backgroundColor: hasSelection ? colors.primary + '30' : colors.border,
//                       color: hasSelection ? colors.primary : colors.textSecondary
//                     }}>
//                       {hasSelection ? '✓ Selected' : 'Not selected'}
//                     </div>
//                   </div>

//                   {/* Veg Option - Checkbox style */}
//                   <div 
//                     className={`flex items-center justify-between p-3 rounded-xl transition-all mb-2 ${
//                       meal.veg ? 'border-2' : 'border'
//                     }`}
//                     style={{ 
//                       backgroundColor: meal.veg ? '#22C55E08' : colors.inputBackground,
//                       borderColor: meal.veg ? '#22C55E' : colors.border,
//                     }}
//                   >
//                     <div 
//                       className="flex items-center gap-3 flex-1" 
//                       onClick={() => toggleCustomMealType(mealTime, 'veg')} 
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <div 
//                         className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all"
//                         style={{
//                           backgroundColor: meal.veg ? '#22C55E' : 'transparent',
//                           border: `2px solid ${meal.veg ? '#22C55E' : colors.border}`
//                         }}
//                       >
//                         {meal.veg && <FaCheck className="text-white text-[10px]" />}
//                       </div>
//                       <span className="text-sm font-medium" style={{ color: colors.text }}>
//                         <FaLeaf className="inline mr-1.5 text-green-500" /> Veg
//                       </span>
//                     </div>
//                     {meal.veg ? (
//                       <div className="flex items-center gap-2 flex-shrink-0">
//                         <button 
//                           className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                           style={{ backgroundColor: '#EF4444', color: 'white' }}
//                           onClick={() => updateCustomMealQty(mealTime, 'veg', -1)}
//                         >
//                           <FaMinus className="text-[10px]" />
//                         </button>
//                         <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
//                           {meal.vegQty}
//                         </span>
//                         <button 
//                           className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                           style={{ backgroundColor: '#22C55E', color: 'white' }}
//                           onClick={() => updateCustomMealQty(mealTime, 'veg', 1)}
//                         >
//                           <FaPlus className="text-[10px]" />
//                         </button>
//                         <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
//                           ₹{price * meal.vegQty}
//                         </span>
//                       </div>
//                     ) : (
//                       <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
//                     )}
//                   </div>

//                   {/* Non-Veg Option - Checkbox style */}
//                   <div 
//                     className={`flex items-center justify-between p-3 rounded-xl transition-all ${
//                       meal.nonVeg ? 'border-2' : 'border'
//                     }`}
//                     style={{ 
//                       backgroundColor: meal.nonVeg ? '#EF444408' : colors.inputBackground,
//                       borderColor: meal.nonVeg ? '#EF4444' : colors.border,
//                     }}
//                   >
//                     <div 
//                       className="flex items-center gap-3 flex-1" 
//                       onClick={() => toggleCustomMealType(mealTime, 'nonVeg')} 
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <div 
//                         className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all"
//                         style={{
//                           backgroundColor: meal.nonVeg ? '#EF4444' : 'transparent',
//                           border: `2px solid ${meal.nonVeg ? '#EF4444' : colors.border}`
//                         }}
//                       >
//                         {meal.nonVeg && <FaCheck className="text-white text-[10px]" />}
//                       </div>
//                       <span className="text-sm font-medium" style={{ color: colors.text }}>
//                         <FaFish className="inline mr-1.5 text-red-500" /> Non-Veg
//                       </span>
//                     </div>
//                     {meal.nonVeg ? (
//                       <div className="flex items-center gap-2 flex-shrink-0">
//                         <button 
//                           className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                           style={{ backgroundColor: '#EF4444', color: 'white' }}
//                           onClick={() => updateCustomMealQty(mealTime, 'nonVeg', -1)}
//                         >
//                           <FaMinus className="text-[10px]" />
//                         </button>
//                         <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
//                           {meal.nonVegQty}
//                         </span>
//                         <button 
//                           className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                           style={{ backgroundColor: '#22C55E', color: 'white' }}
//                           onClick={() => updateCustomMealQty(mealTime, 'nonVeg', 1)}
//                         >
//                           <FaPlus className="text-[10px]" />
//                         </button>
//                         <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
//                           ₹{price * meal.nonVegQty}
//                         </span>
//                       </div>
//                     ) : (
//                       <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
//                     )}
//                   </div>

//                   {/* Summary */}
//                   <div className="mt-3 pt-3 border-t text-sm" style={{ borderColor: colors.border }}>
//                     {hasSelection ? (
//                       <>
//                         {meal.veg && meal.nonVeg && (
//                           <span style={{ color: colors.textSecondary }}>✅ Veg & Non-Veg selected</span>
//                         )}
//                         {meal.veg && !meal.nonVeg && (
//                           <span style={{ color: '#22C55E' }}>✅ Veg selected ({meal.vegQty})</span>
//                         )}
//                         {!meal.veg && meal.nonVeg && (
//                           <span style={{ color: '#EF4444' }}>✅ Non-Veg selected ({meal.nonVegQty})</span>
//                         )}
//                       </>
//                     ) : (
//                       <span style={{ color: colors.textSecondary }}>❌ No meals selected</span>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Action Buttons */}
//           <div className="flex gap-3 mt-6">
//             <button
//               className="flex-1 py-3 rounded-xl text-sm font-medium transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
//               style={{ 
//                 backgroundColor: '#EF444420',
//                 color: '#EF4444',
//                 border: `1px solid #EF444430`
//               }}
//               onClick={handleClearDateMeals}
//             >
//               <FaEraser className="text-sm" /> Clear Plan
//             </button>
//             <button
//               className="flex-1 py-3 rounded-xl text-sm font-medium text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
//               style={{ 
//                 backgroundColor: colors.primary,
//                 boxShadow: `0 4px 20px ${colors.primary}40`
//               }}
//               onClick={handleSaveDateMeals}
//               disabled={!Object.values(dateMealSelections).some(m => m.veg || m.nonVeg)}
//             >
//               <FaSave className="text-sm" /> Save Details
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

// // Alternative: Using native checkbox inputs
// const renderMonthlyMealSelection = () => {
//   return mealItems.map((meal, index) => {
//     const hasSelection = meal.veg.selected || meal.nonVeg.selected;
    
//     return (
//       <div 
//         key={index} 
//         className="rounded-xl p-4 mb-4" 
//         style={{ 
//           backgroundColor: colors.card, 
//           border: `1px solid ${colors.border}`
//         }}
//       >
//         <div className="flex items-center justify-between mb-3">
//           <div>
//             <h4 className="font-bold text-lg" style={{ color: colors.text }}>{meal.meal_time}</h4>
//             <p className="text-xs" style={{ color: colors.textSecondary }}>
//               <FaClock className="inline mr-1 text-[10px]" /> {meal.time_slot}
//             </p>
//           </div>
//           <div className="text-xs px-2 py-1 rounded-full" style={{ 
//             backgroundColor: colors.primary + '20',
//             color: colors.primary
//           }}>
//             {hasSelection ? `${getTotalItems()} meal selected` : 'Select Veg and/or Non-Veg'}
//           </div>
//         </div>

//         {/* Veg Option with native checkbox */}
//         <div 
//           className="flex items-center justify-between p-3 rounded-xl transition-all mb-2"
//           style={{ 
//             backgroundColor: meal.veg.selected ? '#22C55E08' : colors.inputBackground,
//             border: `2px solid ${meal.veg.selected ? '#22C55E' : colors.border}`,
//           }}
//         >
//           <label className="flex items-center gap-3 flex-1 cursor-pointer">
//             <input
//               type="checkbox"
//               checked={meal.veg.selected}
//               onChange={() => toggleVeg(index)}
//               className="w-5 h-5 rounded border-2 transition-all cursor-pointer"
//               style={{
//                 accentColor: '#22C55E',
//                 borderColor: meal.veg.selected ? '#22C55E' : colors.border,
//               }}
//             />
//             <span className="text-sm font-medium" style={{ color: colors.text }}>
//               <FaLeaf className="inline mr-1.5 text-green-500" /> Veg
//             </span>
//           </label>
          
//           {meal.veg.selected ? (
//             <div className="flex items-center gap-2 flex-shrink-0">
//               <button 
//                 className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                 style={{ backgroundColor: '#EF4444', color: 'white' }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   updateVegQuantity(index, -1);
//                 }}
//               >
//                 <FaMinus className="text-[10px]" />
//               </button>
//               <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
//                 {meal.veg.quantity}
//               </span>
//               <button 
//                 className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                 style={{ backgroundColor: '#22C55E', color: 'white' }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   updateVegQuantity(index, 1);
//                 }}
//               >
//                 <FaPlus className="text-[10px]" />
//               </button>
//               <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
//                 ₹{mealPrices[meal.meal_time] * meal.veg.quantity}
//               </span>
//             </div>
//           ) : (
//             <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
//           )}
//         </div>

//         {/* Non-Veg Option with native checkbox */}
//         <div 
//           className="flex items-center justify-between p-3 rounded-xl transition-all"
//           style={{ 
//             backgroundColor: meal.nonVeg.selected ? '#EF444408' : colors.inputBackground,
//             border: `2px solid ${meal.nonVeg.selected ? '#EF4444' : colors.border}`,
//           }}
//         >
//           <label className="flex items-center gap-3 flex-1 cursor-pointer">
//             <input
//               type="checkbox"
//               checked={meal.nonVeg.selected}
//               onChange={() => toggleNonVeg(index)}
//               className="w-5 h-5 rounded border-2 transition-all cursor-pointer"
//               style={{
//                 accentColor: '#EF4444',
//                 borderColor: meal.nonVeg.selected ? '#EF4444' : colors.border,
//               }}
//             />
//             <span className="text-sm font-medium" style={{ color: colors.text }}>
//               <FaFish className="inline mr-1.5 text-red-500" /> Non-Veg
//             </span>
//           </label>
          
//           {meal.nonVeg.selected ? (
//             <div className="flex items-center gap-2 flex-shrink-0">
//               <button 
//                 className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                 style={{ backgroundColor: '#EF4444', color: 'white' }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   updateNonVegQuantity(index, -1);
//                 }}
//               >
//                 <FaMinus className="text-[10px]" />
//               </button>
//               <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
//                 {meal.nonVeg.quantity}
//               </span>
//               <button 
//                 className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
//                 style={{ backgroundColor: '#22C55E', color: 'white' }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   updateNonVegQuantity(index, 1);
//                 }}
//               >
//                 <FaPlus className="text-[10px]" />
//               </button>
//               <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
//                 ₹{mealPrices[meal.meal_time] * meal.nonVeg.quantity}
//               </span>
//             </div>
//           ) : (
//             <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
//           )}
//         </div>
        
//         <div className="mt-3 pt-3 border-t text-sm" style={{ borderColor: colors.border }}>
//           {hasSelection ? (
//             <>
//               {meal.veg.selected && meal.nonVeg.selected && (
//                 <span style={{ color: colors.textSecondary }}>✅ Veg & Non-Veg selected</span>
//               )}
//               {meal.veg.selected && !meal.nonVeg.selected && (
//                 <span style={{ color: '#22C55E' }}>✅ Veg selected ({meal.veg.quantity})</span>
//               )}
//               {!meal.veg.selected && meal.nonVeg.selected && (
//                 <span style={{ color: '#EF4444' }}>✅ Non-Veg selected ({meal.nonVeg.quantity})</span>
//               )}
//             </>
//           ) : (
//             <span style={{ color: colors.textSecondary }}>❌ No meals selected</span>
//           )}
//         </div>
//       </div>
//     );
//   });
// };

//   // ========== MAIN RENDER ==========
//   const token = localStorage.getItem('token');
  
//   if (!token) {
//     return (
//       <div className="min-h-screen flex items-center justify-center" 
//            style={{ backgroundColor: colors.background }}>
//         <div className="text-center p-8 rounded-2xl max-w-md w-full"
//              style={{ 
//                backgroundColor: colors.card,
//                border: `1px solid ${colors.border}`
//              }}>
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 mx-auto" style={{ borderColor: colors.primary }}></div>
//           <p className="mt-4 font-medium" style={{ color: colors.textSecondary }}>
//             Please login to continue...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen w-full flex flex-col" style={{ backgroundColor: colors.background }}>
//       {/* Login Modal */}
//       <LoginModal 
//         isOpen={showLoginModal} 
//         onClose={() => dispatch(setShowLoginModal(false))} 
//       />

//       {/* Full Screen Hero */}
//       <div className="fixed inset-0 w-full h-full flex items-center justify-center overflow-hidden">
//         <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&h=1080&fit=crop)', backgroundSize: 'cover', backgroundPosition: 'center' }} />
//         <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
        
//         <div className="relative z-10 max-w-4xl mx-auto text-center text-white w-full px-4 sm:px-6 lg:px-8">
//           <div className="inline-flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm border border-yellow-400/30 px-5 py-2 rounded-full text-sm font-medium text-yellow-200 mb-6">
//             <FaFire className="text-yellow-400" /> Fresh & Homemade
//           </div>
//           <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-3 leading-tight">Tiffin Express</h1>
//           <p className="text-2xl sm:text-3xl md:text-4xl text-yellow-300 font-semibold mb-4">Dil Se Plate Tak ❤️</p>
//           <p className="text-base sm:text-lg text-white/90 max-w-2xl mx-auto mb-8">Ghar jaisa swaad, har dabbe ke saath. Fresh, homemade meals delivered daily.</p>

//           <div className="flex flex-wrap items-center justify-center gap-6 mb-8 text-sm text-white/70">
//             <span className="flex items-center gap-2"><FaClock className="text-yellow-400" /> Breakfast 7:30-10 AM</span>
//             <span className="w-px h-4 bg-white/20 hidden sm:block"></span>
//             <span className="flex items-center gap-2"><FaClock className="text-yellow-400" /> Lunch 12-2:30 PM</span>
//             <span className="w-px h-4 bg-white/20 hidden sm:block"></span>
//             <span className="flex items-center gap-2"><FaClock className="text-yellow-400" /> Dinner 7:30-10 PM</span>
//           </div>

//           <button 
//             className="px-10 py-4 rounded-full text-white font-semibold text-lg shadow-2xl flex items-center gap-3 mx-auto transition-all hover:scale-105 active:scale-95" 
//             style={{ background: 'linear-gradient(135deg, #FD8A36, #E07324)', boxShadow: '0 8px 40px rgba(253, 138, 54, 0.4)' }} 
//             onClick={handleBookNow}
//           >
//             <FaCalendarCheck className="text-xl" /> Book Now <FaArrowRight className="text-sm" />
//           </button>

//           <div className="flex flex-wrap items-center justify-center gap-6 mt-6 text-sm text-white/60">
//             <span className="flex items-center gap-2"><FaUtensils className="text-yellow-400" /> 42+ Dishes</span>
//             <span className="text-white/20">•</span>
//             <span className="flex items-center gap-2"><FaLeaf className="text-green-400" /> Veg & Non-Veg</span>
//             <span className="text-white/20">•</span>
//             <span className="flex items-center gap-2"><FaTruck className="text-blue-400" /> Free Delivery</span>
//           </div>
//         </div>
//       </div>

//       {/* ========== BOOKING MODAL ========== */}
//       {showModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center px-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={() => setShowModal(false)}>
//           <div className="rounded-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }} onClick={(e) => e.stopPropagation()}>
//             <div className="flex items-center justify-between mb-4">
//               <div>
//                 <h3 className="text-2xl font-bold" style={{ color: colors.text }}>Tiffin Express</h3>
//                 <p className="text-sm" style={{ color: colors.textSecondary }}>Dil Se Plate Tak ❤️</p>
//               </div>
//               <button 
//                 className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" 
//                 style={{ backgroundColor: colors.inputBackground }} 
//                 onClick={() => setShowModal(false)}
//               >
//                 <FaTimes style={{ color: colors.text }} />
//               </button>
//             </div>

//             {/* Weekly Menu Section */}
//             <div className="mb-4 p-3 rounded-xl" style={{ 
//               backgroundColor: colors.primary + '10', 
//               border: `1px solid ${colors.primary}25` 
//             }}>
//               <div className="flex items-center justify-between mb-3">
//                 <div className="flex items-center gap-2">
//                   <FaCalendarWeek className="text-sm" style={{ color: colors.primary }} />
//                   <p className="text-sm font-bold" style={{ color: colors.text }}>
//                     Weekly Menu
//                   </p>
//                 </div>
//                 <span className="text-[8px] px-2 py-0.5 rounded-full" style={{ 
//                   backgroundColor: colors.primary + '20',
//                   color: colors.primary
//                 }}>
//                   {weeklyMenu.length} items
//                 </span>
//               </div>
//               {renderWeeklyMenuInModal()}
//             </div>

//             {/* View Mode Toggle */}
//             <div className="flex gap-2 mb-6 bg-gray-100 dark:bg-gray-800 rounded-xl p-1">
//               <button 
//                 className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${viewMode === 'monthly' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'bg-transparent'}`} 
//                 style={{ color: viewMode === 'monthly' ? colors.primary : colors.textSecondary, boxShadow: viewMode === 'monthly' ? '0 2px 8px rgba(0,0,0,0.08)' : 'none' }} 
//                 onClick={() => setViewMode('monthly')}
//               >
//                 <FaCalendarWeek className="text-xs" /> Monthly Subscription
//               </button>
//               <button 
//                 className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${viewMode === 'custom' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'bg-transparent'}`} 
//                 style={{ color: viewMode === 'custom' ? colors.primary : colors.textSecondary, boxShadow: viewMode === 'custom' ? '0 2px 8px rgba(0,0,0,0.08)' : 'none' }} 
//                 onClick={() => setViewMode('custom')}
//               >
//                 <FaCalendarDay className="text-xs" /> Custom Date
//               </button>
//             </div>

//             {displayError && (
//               <div className="p-3 rounded-xl mb-4 text-sm" style={{ backgroundColor: displayError.includes('active') ? '#FEF3C7' : '#FEF2F2', color: displayError.includes('active') ? '#92400E' : '#DC2626', border: `1px solid ${displayError.includes('active') ? '#FCD34D' : '#FECACA'}` }}>
//                 <div className="flex items-start gap-2">
//                   <FaExclamationTriangle className="mt-0.5 flex-shrink-0" />
//                   <div>
//                     <span>{displayError}</span>
//                     {selectedSubscriptionId && (
//                       <button 
//                         onClick={handleCancelSubscription} 
//                         className="block mt-2 px-4 py-1.5 rounded-lg text-xs font-medium text-white transition-all hover:scale-105" 
//                         style={{ backgroundColor: '#EF4444' }}
//                         disabled={displayError?.includes('already cancelled')}
//                       >
//                         <FaTrash className="inline mr-1.5 text-[10px]" /> Cancel Existing Subscription
//                       </button>
//                     )}
//                     {displayError?.includes('already cancelled') && (
//                       <p className="text-xs mt-2" style={{ color: colors.textSecondary }}>
//                         This subscription has already been cancelled.
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* ========== MONTHLY SUBSCRIPTION VIEW ========== */}
//             {viewMode === 'monthly' && !displayError?.includes('active') && !selectedSubscriptionId && (
//               <div className="space-y-4">
//                 <div className="p-3 rounded-xl" style={{ backgroundColor: colors.primary + '10', border: `1px solid ${colors.primary}25` }}>
//                   <p className="text-sm font-medium flex items-center gap-2" style={{ color: colors.primary }}>
//                     <FaInfoCircle className="text-xs" /> Monthly Setup Plan
//                   </p>
//                   <p className="text-xs" style={{ color: colors.textSecondary }}>Configure your regular daily default meals and selected start date.</p>
//                 </div>

//                 <div>
//                   <label className="text-sm font-medium block mb-1.5" style={{ color: colors.textSecondary }}>📅 Start Date</label>
//                   <div className="flex items-center justify-between p-3 rounded-xl cursor-pointer hover:shadow-md transition-all" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }} onClick={() => setShowCalendar(!showCalendar)}>
//                     <span className="text-sm font-medium" style={{ color: colors.text }}>{formatDate(subscriptionStartDate)}</span>
//                     <FaCalendarAlt style={{ color: colors.primary }} />
//                   </div>
//                   {showCalendar && (
//                     <div className="mt-2 p-3 rounded-xl" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}>
//                       <Calendar onChange={(date) => { setSubscriptionStartDate(date); setShowCalendar(false); }} value={subscriptionStartDate} minDate={new Date()} className="w-full" />
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   <label className="text-sm font-medium block mb-1.5" style={{ color: colors.textSecondary }}>
//                     📍 Delivery Address <span className="text-xs" style={{ color: colors.textSecondary }}>(Required)</span>
//                   </label>
//                   <input
//                     type="text"
//                     value={deliveryAddress}
//                     onChange={(e) => setDeliveryAddress(e.target.value)}
//                     placeholder="Enter your delivery address"
//                     className="w-full p-3 rounded-xl focus:outline-none"
//                     style={{ 
//                       backgroundColor: colors.inputBackground, 
//                       border: `1px solid ${colors.border}`, 
//                       color: colors.text 
//                     }}
//                   />
//                   <p className="text-xs mt-1" style={{ color: colors.primary }}>
//                     📍 This address will be automatically saved to your profile
//                   </p>
//                 </div>

//                 <div>
//                   <label className="text-sm font-medium block mb-2" style={{ color: colors.textSecondary }}>
//                     Select Meals
//                   </label>
//                   {renderMonthlyMealSelection()}
//                 </div>

//                 <button 
//                   className="w-full py-3.5 rounded-xl font-semibold text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2 disabled:opacity-50" 
//                   style={{ 
//                     backgroundColor: colors.primary, 
//                     boxShadow: `0 4px 20px ${colors.primary}40`,
//                     opacity: getTotalItems() > 0 && deliveryAddress.trim() ? 1 : 0.5,
//                     cursor: getTotalItems() > 0 && deliveryAddress.trim() ? 'pointer' : 'not-allowed'
//                   }} 
//                   onClick={handleCreateSubscription}
//                   disabled={isSubscribing || getTotalItems() === 0 || !deliveryAddress.trim()}
//                 >
//                   {isSubscribing ? (
//                     <><FaSpinner className="animate-spin" /> Creating Subscription...</>
//                   ) : (
//                     <><FaCalendarAlt className="inline mr-2" /> Confirm Subscription</>
//                   )}
//                 </button>

//                 {getTotalItems() === 0 && (
//                   <p className="text-center text-xs mt-2" style={{ color: colors.textSecondary }}>
//                     Please select at least one meal (Veg or Non-Veg)
//                   </p>
//                 )}
//                 {deliveryAddress.trim() === '' && getTotalItems() > 0 && (
//                   <p className="text-center text-xs mt-2" style={{ color: colors.textSecondary }}>
//                     Please enter delivery address
//                   </p>
//                 )}
//               </div>
//             )}

//             {displayError?.includes('active') && selectedSubscriptionId && (
//               <div className="text-center py-6">
//                 <div className="text-5xl mb-4">⚠️</div>
//                 <h4 className="text-lg font-bold mb-2" style={{ color: colors.text }}>Active Subscription Found</h4>
//                 <p className="text-sm mb-4" style={{ color: colors.textSecondary }}>
//                   You already have an active subscription (ID: {selectedSubscriptionId}). 
//                   Please cancel it first to create a new one.
//                 </p>
//                 <button 
//                   onClick={handleCancelSubscription} 
//                   className="px-6 py-2.5 rounded-xl text-white font-medium transition-all hover:scale-105 flex items-center justify-center gap-2 mx-auto" 
//                   style={{ backgroundColor: '#EF4444' }}
//                   disabled={localError?.includes('already cancelled')}
//                 >
//                   <FaTrash className="text-sm" /> Cancel Subscription
//                 </button>
//                 {localError?.includes('already cancelled') && (
//                   <p className="text-xs mt-2" style={{ color: colors.textSecondary }}>
//                     This subscription has already been cancelled.
//                   </p>
//                 )}
//               </div>
//             )}

//             {/* ========== CUSTOM DATE VIEW ========== */}
//             {viewMode === 'custom' && (
//               <div className="space-y-4">
//                 <div className="p-3 rounded-xl" style={{ backgroundColor: colors.primary + '10', border: `1px solid ${colors.primary}25` }}>
//                   <p className="text-sm font-medium flex items-center gap-2" style={{ color: colors.primary }}>
//                     <FaInfoCircle className="text-xs" /> Custom Date Order
//                   </p>
//                   <p className="text-xs" style={{ color: colors.textSecondary }}>
//                     Click on any date to select meals for that specific day
//                   </p>
//                 </div>

//                 <div>
//                   <label className="text-sm font-medium block mb-1.5" style={{ color: colors.textSecondary }}>
//                     📍 Delivery Address <span className="text-xs" style={{ color: colors.textSecondary }}>(Required)</span>
//                   </label>
//                   <input
//                     type="text"
//                     value={customDeliveryAddress}
//                     onChange={(e) => setCustomDeliveryAddress(e.target.value)}
//                     placeholder="Enter your delivery address"
//                     className="w-full p-3 rounded-xl focus:outline-none"
//                     style={{ 
//                       backgroundColor: colors.inputBackground, 
//                       border: `1px solid ${colors.border}`, 
//                       color: colors.text 
//                     }}
//                   />
//                   <p className="text-xs mt-1" style={{ color: colors.primary }}>
//                     📍 This address will be automatically saved to your profile
//                   </p>
//                 </div>

//                 {/* Calendar with clickable dates */}
//                 <div className="rounded-xl p-4" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}>
//                   {renderCalendar()}
//                 </div>

//                 {/* Date Meal Selection Modal - Opens when clicking a date */}
//                 <DateMealModal />

//                 {/* Selected Entries Summary */}
//                 {customBookingEntries.length > 0 && (
//                   <div>
//                     <div className="flex items-center justify-between mb-2">
//                       <label className="text-sm font-medium" style={{ color: colors.textSecondary }}>
//                         Selected Meals ({customBookingEntries.length})
//                       </label>
//                       <button
//                         className="text-xs font-medium transition-all hover:scale-105 flex items-center gap-1"
//                         style={{ color: '#EF4444' }}
//                         onClick={handleClearAllEntries}
//                       >
//                         <FaEraser className="text-[10px]" /> Clear All
//                       </button>
//                     </div>
//                     <div className="space-y-2 max-h-40 overflow-y-auto">
//                       {customBookingEntries.map((entry, index) => {
//                         const mealColors = { 'Breakfast': '#F59E0B', 'Lunch': '#F97316', 'Dinner': '#6366F1' };
//                         const price = mealPrices[entry.meal_time] || 60;
//                         return (
//                           <div key={index} className="flex items-center justify-between p-2.5 rounded-lg" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }}>
//                             <div className="text-xs">
//                               <span className="font-semibold" style={{ color: colors.text }}>{formatDate(new Date(entry.date))}</span>
//                               <span className="ml-2" style={{ color: mealColors[entry.meal_time] }}>{entry.meal_time}</span>
//                               <span className="ml-2" style={{ color: colors.primary }}>×{entry.quantity}</span>
//                               <span className="ml-2 text-[8px]" style={{ color: colors.textSecondary }}>₹{price * entry.quantity}</span>
//                             </div>
//                             <button
//                               className="w-8 h-8 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95"
//                               style={{ backgroundColor: '#EF444420', color: '#EF4444' }}
//                               onClick={() => handleRemoveEntry(index)}
//                             >
//                               <FaTrash className="text-xs" />
//                             </button>
//                           </div>
//                         );
//                       })}
//                     </div>
//                     <div className="flex justify-between items-center mt-3">
//                       <div className="text-sm font-bold" style={{ color: colors.primary }}>
//                         Total: ₹{getTotalCustomPrice()}
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 <button
//                   className="w-full py-3.5 rounded-xl font-semibold text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
//                   style={{
//                     backgroundColor: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? colors.primary : colors.border,
//                     boxShadow: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? `0 4px 20px ${colors.primary}40` : 'none',
//                     opacity: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? 1 : 0.5,
//                     cursor: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? 'pointer' : 'not-allowed'
//                   }}
//                   onClick={handleCustomDateOrder}
//                   disabled={isLoading || customBookingEntries.length === 0 || !customDeliveryAddress.trim()}
//                 >
//                   {isLoading ? (
//                     <><FaSpinner className="animate-spin" /> Processing...</>
//                   ) : (
//                     <><FaCalendarCheck /> Confirm Custom Order</>
//                   )}
//                 </button>
//                 {!customDeliveryAddress.trim() && customBookingEntries.length > 0 && (
//                   <p className="text-center text-xs mt-2" style={{ color: colors.textSecondary }}>
//                     Please enter delivery address to confirm order
//                   </p>
//                 )}
//               </div>
//             )}

//             <p className="text-xs text-center mt-4" style={{ color: colors.textSecondary + '80' }}>By booking, you agree to our Terms of Service</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TiffinService;

// src/components/pages/TiffinService.jsx
// src/components/pages/TiffinService.jsx
// src/components/pages/TiffinService.jsx

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getColors } from '../../styles/colors';
import { 
  FaClock, FaFire, FaUtensils, FaLeaf, FaTruck, 
  FaCalendarCheck, FaArrowRight, FaTimes,
  FaCalendarAlt, FaCheck, FaPlus, FaMinus,
  FaCalendarWeek, FaBookmark, FaInfoCircle,
  FaSpinner, FaFish, FaExclamationTriangle,
  FaTrash, FaList, FaCalendarDay, FaSave, FaEraser,
  FaChevronLeft, FaChevronRight, FaCircle, FaMapMarkerAlt,
  FaEdit
} from 'react-icons/fa';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { 
  createSubscriptionAsync, 
  getSubscriptionListAsync, 
  cancelSubscriptionAsync 
} from '../../redux/slices/subscriptionSlice';
import apiService from '../../api/authApi';
import { setShowLoginModal } from '../../redux/slices/authSlice';
import LoginModal from '../common/LoginModal';

const TiffinService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useSelector((state) => state.theme.mode);
  const isDark = theme === 'dark';
  const colors = getColors(isDark);
  
  // Get auth state
  const { showLoginModal } = useSelector((state) => state.auth);
  
  // Get subscription state
  const { isLoading: reduxIsLoading, isSubscribing, error: subscriptionError } = useSelector((state) => state.subscription || {});
  const [isLoading, setIsLoading] = useState(false);
  
  // State for view mode
  const [viewMode, setViewMode] = useState('monthly');
  const [showModal, setShowModal] = useState(false);
  
  // Weekly Menu State
  const [weeklyMenu, setWeeklyMenu] = useState([]);
  const [weeklyMenuLoading, setWeeklyMenuLoading] = useState(false);
  const [weeklyMenuError, setWeeklyMenuError] = useState(null);
  
  // Monthly Subscription State - With checkbox selection
  const [subscriptionStartDate, setSubscriptionStartDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [duration, setDuration] = useState(30);
  const [mealItems, setMealItems] = useState([
    { 
      meal_time: 'Breakfast', 
      time_slot: '07:30 AM - 10:00 AM',
      veg: { selected: false, quantity: 1 }, 
      nonVeg: { selected: false, quantity: 1 }
    },
    { 
      meal_time: 'Lunch', 
      time_slot: '12:00 PM - 02:30 PM',
      veg: { selected: false, quantity: 1 }, 
      nonVeg: { selected: false, quantity: 1 }
    },
    { 
      meal_time: 'Dinner', 
      time_slot: '07:30 PM - 10:00 PM',
      veg: { selected: false, quantity: 1 }, 
      nonVeg: { selected: false, quantity: 1 }
    }
  ]);
  
  // Custom Date State
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [customBookingEntries, setCustomBookingEntries] = useState([]);
  const [customDeliveryAddress, setCustomDeliveryAddress] = useState('');
  
  // Local error state
  const [localError, setLocalError] = useState(null);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  
  // ✅ State for date meal selection modal (Custom Date)
  const [showDateMealModal, setShowDateMealModal] = useState(false);
  const [selectedDateForMeal, setSelectedDateForMeal] = useState(null);
  
  // ✅ Meal selection state for the date modal (similar to monthly but per date)
  const [dateMealSelections, setDateMealSelections] = useState({
    Breakfast: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
    Lunch: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
    Dinner: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 }
  });

  // Meal prices
  const mealPrices = { Breakfast: 50, Lunch: 70, Dinner: 90 };

  // ========== CHECK AUTHENTICATION ==========
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(setShowLoginModal(true));
    }
  }, [dispatch]);

  // ========== EFFECTS ==========
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      checkExistingSubscription();
    }
    
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    if (userData.address) {
      setDeliveryAddress(userData.address);
      setCustomDeliveryAddress(userData.address);
      console.log('📦 Loaded address from profile:', userData.address);
    }
  }, [refreshKey]);

  // ========== PREVENT SCROLLING ON HERO PAGE ==========
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;
    
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = originalOverflow || '';
      document.documentElement.style.overflow = originalHtmlOverflow || '';
    };
  }, []);

  // ========== FETCH WEEKLY MENU ==========
  const fetchWeeklyMenu = async () => {
    setWeeklyMenuLoading(true);
    setWeeklyMenuError(null);
    
    try {
      console.log('🔄 Fetching weekly menu from API...');
      const response = await apiService.getWeeklyMenu();
      console.log('✅ Weekly menu response:', response);
      
      let menuItems = [];
      
      if (response?.data && Array.isArray(response.data)) {
        menuItems = response.data;
      } else if (response?.grouped) {
        const grouped = response.grouped;
        Object.keys(grouped).forEach(day => {
          if (Array.isArray(grouped[day])) {
            grouped[day].forEach(item => {
              menuItems.push({
                ...item,
                day: day
              });
            });
          }
        });
      } else if (response?.data && typeof response.data === 'object') {
        const grouped = response.data;
        Object.keys(grouped).forEach(day => {
          if (Array.isArray(grouped[day])) {
            grouped[day].forEach(item => {
              menuItems.push({
                ...item,
                day: day
              });
            });
          }
        });
      } else if (Array.isArray(response)) {
        menuItems = response;
      }
      
      setWeeklyMenu(menuItems);
      console.log(`✅ Loaded ${menuItems.length} weekly menu items`);
    } catch (error) {
      console.error('❌ Failed to fetch weekly menu:', error);
      setWeeklyMenuError(error.message || 'Failed to load menu');
      setWeeklyMenu([]);
    } finally {
      setWeeklyMenuLoading(false);
    }
  };

  // ========== SUBSCRIPTION FUNCTIONS ==========
  const checkExistingSubscription = async () => {
    try {
      const result = await dispatch(getSubscriptionListAsync()).unwrap();
      console.log('📦 Subscription list check:', result);
      
      if (result?.data && result.data.length > 0) {
        const activeSubscription = result.data.find(sub => 
          sub.status?.toLowerCase() === 'pending_payment' || 
          sub.status?.toLowerCase() === 'active'
        );
        
        if (activeSubscription) {
          setLocalError(`You already have an active subscription (ID: ${activeSubscription.id}). Cancel it first to start a new one.`);
          setSelectedSubscriptionId(activeSubscription.id);
        } else {
          setLocalError(null);
          setSelectedSubscriptionId(null);
        }
      } else {
        setLocalError(null);
        setSelectedSubscriptionId(null);
      }
    } catch (err) {
      console.log('No existing subscriptions or error fetching:', err);
      setLocalError(null);
      setSelectedSubscriptionId(null);
    }
  };

  // ========== UPDATE USER PROFILE ADDRESS ==========
  const updateUserProfileAddress = async (address, name, phone) => {
    try {
      console.log('📤 Updating user profile with address:', address);
      
      const userData = {
        name: name,
        phone: phone,
        address: address
      };
      
      const response = await apiService.updateUserProfile(userData);
      console.log('✅ Profile updated with address:', response);
      
      const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
      storedUser.address = address;
      storedUser.name = name;
      storedUser.phone = phone;
      localStorage.setItem('user', JSON.stringify(storedUser));
      
      const authUser = JSON.parse(localStorage.getItem('tiffinUserLogin') || '{}');
      authUser.address = address;
      authUser.name = name;
      authUser.phone = phone;
      localStorage.setItem('tiffinUserLogin', JSON.stringify(authUser));
      
      window.dispatchEvent(new CustomEvent('profileUpdated', { 
        detail: { 
          name: name,
          phone: phone,
          address: address 
        } 
      }));
      window.dispatchEvent(new Event('storage'));
      
      return true;
    } catch (error) {
      console.error('❌ Failed to update profile address:', error);
      return false;
    }
  };

  // ========== CALENDAR FUNCTIONS ==========
  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    return { daysInMonth, firstDay };
  };

  const navigateMonth = (direction) => {
    const newDate = new Date(currentMonth);
    newDate.setMonth(newDate.getMonth() + direction);
    setCurrentMonth(newDate);
  };

  const getDateStr = (month, day) => {
    const year = month.getFullYear();
    const monthNum = String(month.getMonth() + 1).padStart(2, '0');
    const dayStr = String(day).padStart(2, '0');
    return `${year}-${monthNum}-${dayStr}`;
  };

  const getMealsForDate = (dateStr) => {
    return customBookingEntries.filter(entry => entry.date === dateStr);
  };

  // ✅ Handle date click - OPEN MEAL SELECTION MODAL for Custom Date
  const handleDateClick = (day) => {
    const dateStr = getDateStr(currentMonth, day);
    setSelectedDate(day);
    setSelectedDateForMeal(dateStr);
    
    const existingMeals = customBookingEntries.filter(entry => entry.date === dateStr);
    
    const newMealSelections = {
      Breakfast: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
      Lunch: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 },
      Dinner: { veg: false, nonVeg: false, vegQty: 1, nonVegQty: 1 }
    };
    
    existingMeals.forEach(meal => {
      const time = meal.meal_time;
      if (meal.meal_type === 'Veg') {
        newMealSelections[time].veg = true;
        newMealSelections[time].vegQty = meal.quantity || 1;
      } else if (meal.meal_type === 'Non-Veg') {
        newMealSelections[time].nonVeg = true;
        newMealSelections[time].nonVegQty = meal.quantity || 1;
      }
    });
    
    setDateMealSelections(newMealSelections);
    setShowDateMealModal(true);
  };

  // ✅ Toggle meal type for custom date
  const toggleCustomMealType = (mealTime, type) => {
    setDateMealSelections(prev => ({
      ...prev,
      [mealTime]: {
        ...prev[mealTime],
        [type]: !prev[mealTime][type]
      }
    }));
  };

  // ✅ Update quantity for custom date meal
  const updateCustomMealQty = (mealTime, type, delta) => {
    setDateMealSelections(prev => {
      const key = type === 'veg' ? 'vegQty' : 'nonVegQty';
      const currentQty = prev[mealTime][key];
      const newQty = Math.max(0, currentQty + delta);
      return {
        ...prev,
        [mealTime]: {
          ...prev[mealTime],
          [key]: newQty
        }
      };
    });
  };

  // ✅ Save date meals for custom date
  const handleSaveDateMeals = () => {
    const dateStr = selectedDateForMeal;
    if (!dateStr) return;

    const hasAnySelection = Object.values(dateMealSelections).some(
      meal => meal.veg || meal.nonVeg
    );
    
    if (!hasAnySelection) {
      alert('Please select at least one meal (Veg or Non-Veg) for this date.');
      return;
    }

    const filteredEntries = customBookingEntries.filter(entry => entry.date !== dateStr);
    
    const newEntries = [];
    const mealTimes = ['Breakfast', 'Lunch', 'Dinner'];
    
    mealTimes.forEach(mealTime => {
      const meal = dateMealSelections[mealTime];
      if (meal.veg && meal.vegQty > 0) {
        newEntries.push({
          date: dateStr,
          meal_time: mealTime,
          meal_type: 'Veg',
          quantity: parseInt(meal.vegQty) || 1
        });
      }
      if (meal.nonVeg && meal.nonVegQty > 0) {
        newEntries.push({
          date: dateStr,
          meal_time: mealTime,
          meal_type: 'Non-Veg',
          quantity: parseInt(meal.nonVegQty) || 1
        });
      }
    });
    
    setCustomBookingEntries([...filteredEntries, ...newEntries]);
    setShowDateMealModal(false);
    setSelectedDateForMeal(null);
  };

  // ✅ Clear all meals for the selected date
  const handleClearDateMeals = () => {
    const dateStr = selectedDateForMeal;
    if (!dateStr) return;
    
    if (!window.confirm('Are you sure you want to clear all meals for this date?')) return;
    
    const filteredEntries = customBookingEntries.filter(entry => entry.date !== dateStr);
    setCustomBookingEntries(filteredEntries);
    setShowDateMealModal(false);
    setSelectedDateForMeal(null);
  };

  const handleRemoveEntry = (index) => {
    setCustomBookingEntries(prev => prev.filter((_, i) => i !== index));
  };

  const handleClearAllEntries = () => {
    if (customBookingEntries.length === 0) return;
    if (window.confirm('Are you sure you want to clear all entries?')) {
      setCustomBookingEntries([]);
    }
  };

  // ========== CUSTOM DATE ORDER ==========
  const handleCustomDateOrder = async () => {
    if (customBookingEntries.length === 0) {
      alert('Please add at least one meal entry before confirming.');
      return;
    }

    if (!customDeliveryAddress.trim()) {
      alert('Please enter your delivery address for this custom order.');
      return;
    }

    setLocalError(null);
    setIsLoading(true);

    try {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const userName = userData.name || 'Customer';
      const userPhone = userData.phone || '';
      
      await updateUserProfileAddress(customDeliveryAddress.trim(), userName, userPhone);
      console.log('✅ Profile address updated for custom order');

      const groupedByDate = {};
      customBookingEntries.forEach(entry => {
        const dateKey = entry.date;
        if (!groupedByDate[dateKey]) {
          groupedByDate[dateKey] = [];
        }
        groupedByDate[dateKey].push({
          meal_time: entry.meal_time,
          meal_type: entry.meal_type,
          quantity: parseInt(entry.quantity) || 1
        });
      });

      const bookings = Object.keys(groupedByDate).map(date => ({
        date: date,
        items: groupedByDate[date]
      }));

      const payload = {
        bookings: bookings
      };

      console.log('📤 Sending custom date order payload:', JSON.stringify(payload, null, 2));
      console.log('📅 Booking dates:', bookings.map(b => b.date));

      const token = localStorage.getItem('token');
      const response = await fetch('https://admin.thefoodies.in/api/tiffin/date-wise/order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const responseData = await response.json();
      console.log('📥 Response:', responseData);

      if (response.ok && responseData.status) {
        const orderData = responseData.data || responseData;
        const orderId = orderData.order_id || orderData.id;
        const orderNumber = orderData.order_number || `TIF${orderId}`;
        
        const totalAmount = customBookingEntries.reduce((sum, entry) => {
          const price = mealPrices[entry.meal_time] || 60;
          return sum + (price * (parseInt(entry.quantity) || 1));
        }, 0);
        
        const savedOrders = JSON.parse(localStorage.getItem('customOrders') || '[]');
        
        const itemsWithDates = customBookingEntries.map(entry => ({
          ...entry,
          date: entry.date,
          meal_time: entry.meal_time,
          meal_type: entry.meal_type,
          quantity: parseInt(entry.quantity) || 1,
          price: mealPrices[entry.meal_time] || 60,
          subtotal: (mealPrices[entry.meal_time] || 60) * (parseInt(entry.quantity) || 1)
        }));
        
        const newOrder = {
          ...orderData,
          id: orderId,
          order_number: orderNumber,
          order_id: orderId,
          created_at: new Date().toISOString(),
          date: new Date().toISOString(),
          total: totalAmount,
          total_amount: totalAmount,
          items: itemsWithDates,
          payment_status: orderData.payment_status || 'pending',
          order_status: orderData.order_status || 'confirmed',
          status: orderData.status || 'pending',
          order_type: 'tiffin_date_wise',
          delivery_address: customDeliveryAddress.trim()
        };
        savedOrders.unshift(newOrder);
        localStorage.setItem('customOrders', JSON.stringify(savedOrders));
        
        console.log('✅ Order saved with dates:', itemsWithDates.map(i => ({ date: i.date, meal: i.meal_time })));
        
        //const confirmMessage = `🎉 Custom Date Order Confirmed!\n\n` +
          //`📅 ${customBookingEntries.length} meal(s) booked\n` +
         // `💰 Total Amount: ₹${totalAmount}\n` +
          //`🧾 Order ID: ${orderNumber}\n` +
          //`📍 Delivery Address: ${customDeliveryAddress.trim()}\n\n` +
          //`📋 Order saved to My Orders!`;
        
        //alert(confirmMessage);
        
        setCustomBookingEntries([]);
        setShowModal(false);
        navigate('/my-orders');
      } else {
        const errorMessage = responseData.message || responseData.error || 'Order placement failed';
        console.error('❌ API Error:', responseData);
        
        if (responseData.errors) {
          const validationErrors = Object.values(responseData.errors).flat().join('\n');
          throw new Error(`Validation failed:\n${validationErrors}`);
        }
        
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error('❌ Custom date order failed:', error);
      let errorMsg = 'Order placement failed. Please try again.';
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (error.message) {
        errorMsg = error.message;
      }
      setLocalError(errorMsg);
      alert(`❌ ${errorMsg}`);
    } finally {
      setIsLoading(false);
    }
  };

  // ========== MEAL ITEM FUNCTIONS (Monthly) - FIXED ==========
  const toggleVeg = useCallback((index) => {
    console.log('🔄 Toggling Veg for index:', index);
    setMealItems(prev => {
      const newItems = prev.map((item, i) => {
        if (i !== index) return item;
        const selected = !item.veg.selected;
        console.log(`📊 Veg for index ${index}: ${item.veg.selected} -> ${selected}`);
        return { 
          ...item, 
          veg: { 
            selected: selected, 
            quantity: selected ? 1 : 0 
          } 
        };
      });
      return newItems;
    });
  }, []);

  const toggleNonVeg = useCallback((index) => {
    console.log('🔄 Toggling Non-Veg for index:', index);
    setMealItems(prev => {
      const newItems = prev.map((item, i) => {
        if (i !== index) return item;
        const selected = !item.nonVeg.selected;
        console.log(`📊 Non-Veg for index ${index}: ${item.nonVeg.selected} -> ${selected}`);
        return { 
          ...item, 
          nonVeg: { 
            selected: selected, 
            quantity: selected ? 1 : 0 
          } 
        };
      });
      return newItems;
    });
  }, []);

  const updateVegQuantity = useCallback((index, delta) => {
    setMealItems(prev =>
      prev.map((item, i) => {
        if (i !== index) return item;
        const newQty = Math.max(0, item.veg.quantity + delta);
        return { 
          ...item, 
          veg: { 
            quantity: newQty, 
            selected: newQty > 0 
          } 
        };
      })
    );
  }, []);

  const updateNonVegQuantity = useCallback((index, delta) => {
    setMealItems(prev =>
      prev.map((item, i) => {
        if (i !== index) return item;
        const newQty = Math.max(0, item.nonVeg.quantity + delta);
        return { 
          ...item, 
          nonVeg: { 
            quantity: newQty, 
            selected: newQty > 0 
          } 
        };
      })
    );
  }, []);

  const buildSubscriptionItems = () => {
    const items = [];
    
    mealItems.forEach(meal => {
      if (meal.veg.selected && meal.veg.quantity > 0) {
        items.push({
          meal_time: meal.meal_time,
          meal_type: 'Veg',
          quantity: meal.veg.quantity
        });
      }
      if (meal.nonVeg.selected && meal.nonVeg.quantity > 0) {
        items.push({
          meal_time: meal.meal_time,
          meal_type: 'Non-Veg',
          quantity: meal.nonVeg.quantity
        });
      }
    });
    
    return items;
  };

  const buildBookings = () => {
    const start = new Date(subscriptionStartDate);
    const items = buildSubscriptionItems();
    const bookings = [];
    
    for (let i = 0; i < duration; i++) {
      const date = new Date(start);
      date.setDate(date.getDate() + i);
      const dateStr = date.toISOString().split('T')[0];
      
      bookings.push({
        date: dateStr,
        items: items.map(item => ({ ...item }))
      });
    }
    
    return bookings;
  };

  const getTotalItems = () => {
    let count = 0;
    mealItems.forEach(meal => {
      if (meal.veg.selected && meal.veg.quantity > 0) count += meal.veg.quantity;
      if (meal.nonVeg.selected && meal.nonVeg.quantity > 0) count += meal.nonVeg.quantity;
    });
    return count;
  };

  const getDailyPrice = () => {
    let total = 0;
    mealItems.forEach(meal => {
      const price = mealPrices[meal.meal_time] || 60;
      if (meal.veg.selected && meal.veg.quantity > 0) {
        total += price * meal.veg.quantity;
      }
      if (meal.nonVeg.selected && meal.nonVeg.quantity > 0) {
        total += price * meal.nonVeg.quantity;
      }
    });
    return total;
  };

  const getTotalPrice = () => {
    return getDailyPrice() * duration;
  };

  // ========== MONTHLY SUBSCRIPTION ==========
  const handleCreateSubscription = async () => {
    setLocalError(null);
    
    try {
      const items = buildSubscriptionItems();
      
      if (items.length === 0) {
        setLocalError('Please select at least one meal');
        return;
      }

      if (!deliveryAddress.trim()) {
        setLocalError('Please enter delivery address');
        return;
      }

      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const userName = userData.name || 'Customer';
      const userPhone = userData.phone || '';
      
      await updateUserProfileAddress(deliveryAddress.trim(), userName, userPhone);
      console.log('✅ Profile address updated for monthly subscription');

      const bookings = buildBookings();

      const payload = {
        start_date: subscriptionStartDate.toISOString().split('T')[0],
        delivery_address: deliveryAddress.trim(),
        items: items,
        bookings: bookings
      };
      
      console.log('🚀 MONTHLY SUBSCRIPTION PAYLOAD:', JSON.stringify(payload, null, 2));
      
      const result = await dispatch(createSubscriptionAsync(payload)).unwrap();
      
      console.log('✅ Subscription created:', result);
      
      if (result.status) {
        const data = result.data;
        
        //const confirmMessage = `🎉 Monthly Subscription Created!\n\n` +
        //  `📅 Start Date: ${data.start_date || payload.start_date}\n` +
         // `📅 End Date: ${data.end_date || 'N/A'}\n` +
          //`💰 Total: ₹${data.projected_total || getTotalPrice()}\n` +
         // `💳 Deposit (50%): ₹${data.deposit_amount || Math.round(getTotalPrice() * 0.5)}\n` +
         // `📋 Status: ${data.status || 'Pending'}\n\n` +
          //`📊 Items:\n${items.map(item => 
         //   `  • ${item.meal_time} (${item.meal_type}) × ${item.quantity}`
        //  ).join('\n')}\n\n` +
          //`📦 Delivery Address: ${payload.delivery_address}`;
        
        //alert(confirmMessage);
        setShowModal(false);
        navigate('/my-orders');
      }
    } catch (err) {
      console.error('❌ Subscription failed:', err);
      let errorMsg = 'Failed to create subscription';
      if (typeof err === 'string') {
        errorMsg = err;
      } else if (err.response?.data?.message) {
        errorMsg = err.response.data.message;
        if (errorMsg.includes('already have an active or pending monthly subscription')) {
          errorMsg = '⚠️ You already have an active subscription. Please cancel it first.';
          await checkExistingSubscription();
        }
      } else if (err.message) {
        errorMsg = err.message;
      }
      setLocalError(errorMsg);
      alert(`❌ ${errorMsg}`);
    }
  };

  // ========== CANCEL SUBSCRIPTION ==========
  const handleCancelSubscription = async () => {
    if (!selectedSubscriptionId) {
      alert('No subscription found to cancel.');
      return;
    }
    
    if (!window.confirm(`Are you sure you want to cancel subscription #${selectedSubscriptionId}?`)) {
      return;
    }
    
    try {
      const result = await dispatch(cancelSubscriptionAsync(selectedSubscriptionId)).unwrap();
      console.log('✅ Subscription cancelled:', result);
      alert('✅ Subscription cancelled successfully!');
      
      setSelectedSubscriptionId(null);
      setLocalError(null);
      
      await checkExistingSubscription();
      
      setRefreshKey(prev => prev + 1);
      
    } catch (err) {
      console.error('❌ Cancel subscription failed:', err);
      
      const errorMsg = typeof err === 'string' ? err : err?.message || err?.error || '';
      
      if (errorMsg.includes('already cancelled') || errorMsg.includes('already canceled')) {
        alert('ℹ️ This subscription has already been cancelled.');
        setSelectedSubscriptionId(null);
        setLocalError(null);
        await checkExistingSubscription();
        setRefreshKey(prev => prev + 1);
      } else {
        alert('❌ Failed to cancel subscription. Please try again.');
      }
    }
  };

  // ========== UI HELPERS ==========
  const getMealPrice = (mealTime) => {
    return mealPrices[mealTime] || 60;
  };

  const getTotalCustomPrice = () => {
    return customBookingEntries.reduce((sum, entry) => {
      const price = mealPrices[entry.meal_time] || 60;
      return sum + (price * entry.quantity);
    }, 0);
  };

  const handleBookNow = async () => {
    setViewMode('monthly');
    setShowModal(true);
    await fetchWeeklyMenu();
  };

  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const displayError = localError || subscriptionError;

  // ========== RENDER WEEKLY MENU ==========
  const renderWeeklyMenuInModal = () => {
    if (weeklyMenuLoading) {
      return (
        <div className="text-center py-4">
          <FaSpinner className="animate-spin text-2xl mx-auto" style={{ color: colors.primary }} />
          <p className="text-xs mt-1" style={{ color: colors.textSecondary }}>Loading weekly menu...</p>
        </div>
      );
    }

    if (weeklyMenuError) {
      return (
        <div className="text-center py-4">
          <p className="text-xs text-red-500">{weeklyMenuError}</p>
          <button
            onClick={fetchWeeklyMenu}
            className="mt-2 px-3 py-1 rounded-lg text-xs text-white transition-all hover:scale-105"
            style={{ backgroundColor: colors.primary }}
          >
            Retry
          </button>
        </div>
      );
    }

    if (!weeklyMenu || weeklyMenu.length === 0) {
      return (
        <div className="text-center py-4">
          <p className="text-xs" style={{ color: colors.textSecondary }}>No weekly menu items available</p>
        </div>
      );
    }

    const groupedByDay = {};
    weeklyMenu.forEach(item => {
      const day = item.day || item.Day || 'Unknown';
      if (!groupedByDay[day]) {
        groupedByDay[day] = [];
      }
      groupedByDay[day].push(item);
    });

    const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const mealTypeOrder = ['Breakfast', 'Lunch', 'Dinner'];

    return (
      <div className="space-y-4 max-h-80 overflow-y-auto pr-1" style={{ 
        maxHeight: '280px',
        scrollbarWidth: 'thin',
        scrollbarColor: `${colors.primary} transparent`
      }}>
        {dayOrder.map(day => {
          if (!groupedByDay[day] || groupedByDay[day].length === 0) return null;
          
          return (
            <div 
              key={day} 
              className="rounded-xl overflow-hidden"
              style={{ 
                backgroundColor: colors.card,
                border: `1px solid ${colors.border}`,
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
              }}
            >
              <div 
                className="px-4 py-2 flex items-center"
                style={{ 
                  background: `linear-gradient(135deg, ${colors.primary}20, ${colors.primary}10)`,
                  borderBottom: `1px solid ${colors.border}`
                }}
              >
                <span className="text-sm font-bold" style={{ color: colors.primary }}>{day}</span>
                <span className="ml-auto text-[10px] px-2 py-0.5 rounded-full" style={{ 
                  backgroundColor: colors.primary + '20',
                  color: colors.primary
                }}>
                  {groupedByDay[day].length} items
                </span>
              </div>

              <div className="p-3 space-y-3">
                {mealTypeOrder.map(mealType => {
                  const items = groupedByDay[day].filter(item => {
                    const time = item.available_time || item.meal_time || 'Other';
                    return time === mealType;
                  });
                  
                  if (items.length === 0) return null;
                  
                  return (
                    <div key={mealType} className="space-y-2">
                      <div className="flex items-center gap-2">
                        <span className="text-sm font-semibold" style={{ color: colors.text }}>{mealType}</span>
                      </div>
                      
                      {['Veg', 'Non-Veg'].map(type => {
                        const typeItems = items.filter(item => {
                          const itemType = item.meal_type || item.type || 'Veg';
                          return itemType === type || (type === 'Veg' && (itemType === 'Veg' || itemType === 'veg'));
                        });
                        
                        if (typeItems.length === 0) return null;
                        
                        const isVeg = type === 'Veg';
                        
                        return (
                          <div 
                            key={type}
                            className="rounded-lg p-2"
                            style={{ 
                              backgroundColor: isVeg ? '#22C55E10' : '#EF444410',
                              border: `1px solid ${isVeg ? '#22C55E30' : '#EF444430'}`
                            }}
                          >
                            <div className="flex items-center gap-1.5 mb-1.5">
                              <FaCircle className="text-[8px]" style={{ color: isVeg ? '#22C55E' : '#EF4444' }} />
                              <span className="text-xs font-medium" style={{ color: isVeg ? '#22C55E' : '#EF4444' }}>
                                {type}
                              </span>
                            </div>
                            
                            <div className="space-y-1">
                              {typeItems.map((item, idx) => {
                                const foodName = item.food_name || item.name || 'Menu Item';
                                const price = item.price || item.amount || 0;
                                const availableFood = item.available_food || '';
                                const foodItems = availableFood ? availableFood.split('.').filter(f => f.trim()) : [];
                                                                return (
                                  <div
                                    key={idx}
                                    className="px-2 py-1.5 rounded cursor-pointer hover:shadow-sm transition-all"
                                    style={{ 
                                      backgroundColor: isVeg ? '#22C55E08' : '#EF444408',
                                      border: `1px solid ${isVeg ? '#22C55E15' : '#EF444415'}`
                                    }}
                                   // onClick={() => {
                                    //  alert(`🍽️ ${foodName}\n💰 ₹${price}\n🥗 ${type}\n📅 ${day}\n⏰ ${mealType}\n\n📋 Menu:\n${foodItems.map((f, i) => `  ${i+1}. ${f.trim()}`).join('\n')}`);
                                   // }}
                                  >
                                    <div className="flex items-center justify-between">
                                      <div className="flex-1 min-w-0">
                                        <span className="text-xs font-medium truncate block" style={{ color: colors.text }}>
                                          {foodName}
                                        </span>
                                        {foodItems.length > 0 && (
                                          <div className="text-[10px] truncate block" style={{ color: colors.textSecondary }}>
                                            {foodItems.map((f, i) => (
                                              <span key={i}>
                                                {i > 0 && ', '}{f.trim()}
                                              </span>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                      <span className="text-xs font-bold flex-shrink-0 ml-2" style={{ color: colors.primary }}>
                                        ₹{price}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        
        <div className="text-center text-[10px] py-1" style={{ color: colors.textSecondary }}>
          {weeklyMenu.length} items total • {Object.keys(groupedByDay).length} days
        </div>
      </div>
    );
  };

  // ========== RENDER CALENDAR (Custom Date) ==========
  // ========== RENDER CALENDAR (Custom Date) - WITH DATE BLOCKING ==========
// ========== RENDER CALENDAR (Custom Date) - WITH DATE BLOCKING ==========
const renderCalendar = () => {
  const { daysInMonth, firstDay } = getDaysInMonth(currentMonth);
  const monthName = currentMonth.toLocaleString('default', { month: 'long' });
  const year = currentMonth.getFullYear();

  const days = [];
  
  // Get today's date for comparison
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  
  for (let i = 0; i < firstDay; i++) {
    days.push(<div key={`empty-${i}`} className="w-12 h-12" />);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = getDateStr(currentMonth, day);
    const hasMeal = customBookingEntries.some(entry => entry.date === dateStr);
    const isToday = day === new Date().getDate() && 
                   currentMonth.getMonth() === new Date().getMonth() &&
                   currentMonth.getFullYear() === new Date().getFullYear();
    
    // ✅ Check if date is in the past (before today)
    const isPastDate = dateStr < todayStr;
    
    days.push(
      <button
        key={day}
        className={`w-12 h-12 rounded-xl text-sm font-medium transition-all relative ${
          hasMeal ? 'border-2' : ''
        } ${isToday ? 'ring-2 ring-offset-2' : ''} ${
          isPastDate ? 'opacity-40 cursor-not-allowed' : 'hover:scale-105 cursor-pointer'
        }`}
        style={{
          backgroundColor: isPastDate ? 'transparent' : (hasMeal ? colors.primary : 'transparent'),
          color: isPastDate ? colors.textSecondary : (hasMeal ? '#FFFFFF' : colors.text),
          borderColor: hasMeal ? colors.primary : colors.border,
          ...(isToday && { ringColor: colors.primary }),
          pointerEvents: isPastDate ? 'none' : 'auto'
        }}
        onClick={() => {
          if (!isPastDate) {
            handleDateClick(day);
          }
        }}
        disabled={isPastDate}
      >
        {day}
        {hasMeal && (
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-green-500 border-2 border-white dark:border-gray-800" />
        )}
      </button>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold" style={{ color: colors.text }}>
          {monthName} {year}
        </h3>
        <div className="flex gap-2">
          <button
            onClick={() => navigateMonth(-1)}
            className="p-2 rounded-full transition-all hover:scale-110"
            style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}
          >
            <FaChevronLeft style={{ color: colors.text }} />
          </button>
          <button
            onClick={() => navigateMonth(1)}
            className="p-2 rounded-full transition-all hover:scale-110"
            style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}
          >
            <FaChevronRight style={{ color: colors.text }} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-7 gap-1">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
          <div key={day} className="text-center text-xs font-medium py-1" style={{ color: colors.textSecondary }}>
            {day}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1">
        {days}
      </div>

      <div className="flex items-center gap-4 pt-2 border-t flex-wrap" style={{ borderColor: colors.border }}>
        <div className="flex items-center gap-1 text-xs" style={{ color: colors.textSecondary }}>
          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: colors.primary }} />
          Selected
        </div>
        <div className="flex items-center gap-1 text-xs" style={{ color: colors.textSecondary }}>
          <div className="w-3 h-3 rounded-full bg-green-500" />
          Has Meal
        </div>
        <div className="flex items-center gap-1 text-xs" style={{ color: colors.textSecondary }}>
          <div className="w-3 h-3 rounded-full bg-gray-400 opacity-40" />
          Past Date
        </div>
      </div>
      
      {/* Show message for past dates */}
      <div className="text-xs text-center" style={{ color: colors.textSecondary }}>
        Past dates are disabled. Select future dates to book meals.
      </div>
    </div>
  );
};

  // ========== DATE MEAL SELECTION MODAL (Custom Date) ==========
  const DateMealModal = () => {
    if (!showDateMealModal || !selectedDateForMeal) return null;

    const dateObj = new Date(selectedDateForMeal);
    const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'long' });
    const monthName = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const dayNum = dateObj.getDate();
    const mealTimes = ['Breakfast', 'Lunch', 'Dinner'];

    return (
      <div 
        className="fixed inset-0 z-50 flex items-center justify-center px-4"
        style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
        onClick={() => setShowDateMealModal(false)}
      >
        <div
          className="rounded-2xl p-6 max-w-md w-full max-h-[90vh] overflow-y-auto"
          style={{ 
            backgroundColor: colors.card,
            border: `1px solid ${colors.border}`
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between mb-4">
            <div>
              <h3 className="text-xl font-bold" style={{ color: colors.text }}>
                {dayName}, {dayNum} {monthName}
              </h3>
              <p className="text-sm" style={{ color: colors.textSecondary }}>
                Select meals for this date
              </p>
            </div>
            <button 
              className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
              style={{ backgroundColor: colors.inputBackground }}
              onClick={() => setShowDateMealModal(false)}
            >
              <FaTimes style={{ color: colors.text }} />
            </button>
          </div>

          <div className="space-y-4">
            {mealTimes.map(mealTime => {
              const meal = dateMealSelections[mealTime];
              const hasSelection = meal.veg || meal.nonVeg;
              const price = mealPrices[mealTime] || 60;
              
              return (
                <div 
                  key={mealTime}
                  className="rounded-xl p-4"
                  style={{ 
                    backgroundColor: colors.inputBackground,
                    border: `1px solid ${colors.border}`
                  }}
                >
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h4 className="font-bold text-base" style={{ color: colors.text }}>{mealTime}</h4>
                      <p className="text-xs" style={{ color: colors.textSecondary }}>
                        <FaClock className="inline mr-1 text-[10px]" /> 
                        {mealTime === 'Breakfast' ? '07:30 AM - 10:00 AM' : 
                         mealTime === 'Lunch' ? '12:00 PM - 02:30 PM' : 
                         '07:30 PM - 10:00 PM'}
                      </p>
                    </div>
                    <div className="text-xs px-2 py-0.5 rounded-full" style={{ 
                      backgroundColor: hasSelection ? colors.primary + '30' : colors.border,
                      color: hasSelection ? colors.primary : colors.textSecondary
                    }}>
                      {hasSelection ? '✓ Selected' : 'Not selected'}
                    </div>
                  </div>

                  {/* Veg Option */}
                  <div 
                    className={`flex items-center justify-between p-3 rounded-xl transition-all mb-2 cursor-pointer`}
                    style={{ 
                      backgroundColor: meal.veg ? '#22C55E08' : colors.inputBackground,
                      border: `2px solid ${meal.veg ? '#22C55E' : colors.border}`,
                    }}
                    onClick={() => toggleCustomMealType(mealTime, 'veg')}
                  >
                    <div className="flex items-center gap-3 flex-1">
                      <div 
                        className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all"
                        style={{
                          backgroundColor: meal.veg ? '#22C55E' : 'transparent',
                          border: `2px solid ${meal.veg ? '#22C55E' : colors.border}`
                        }}
                      >
                        {meal.veg && <FaCheck className="text-white text-[10px]" />}
                      </div>
                      <span className="text-sm font-medium" style={{ color: colors.text }}>
                        <FaLeaf className="inline mr-1.5 text-green-500" /> Veg
                      </span>
                    </div>
                    {meal.veg ? (
                      <div className="flex items-center gap-2 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                        <button 
                          className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                          style={{ backgroundColor: '#EF4444', color: 'white' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            updateCustomMealQty(mealTime, 'veg', -1);
                          }}
                        >
                          <FaMinus className="text-[10px]" />
                        </button>
                        <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
                          {meal.vegQty}
                        </span>
                        <button 
                          className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                          style={{ backgroundColor: '#22C55E', color: 'white' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            updateCustomMealQty(mealTime, 'veg', 1);
                          }}
                        >
                          <FaPlus className="text-[10px]" />
                        </button>
                        <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
                          ₹{price * meal.vegQty}
                        </span>
                      </div>
                    ) : (
                      <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
                    )}
                  </div>

                  {/* Non-Veg Option */}
                  <div 
                    className={`flex items-center justify-between p-3 rounded-xl transition-all cursor-pointer`}
                    style={{ 
                      backgroundColor: meal.nonVeg ? '#EF444408' : colors.inputBackground,
                      border: `2px solid ${meal.nonVeg ? '#EF4444' : colors.border}`,
                    }}
                    onClick={() => toggleCustomMealType(mealTime, 'nonVeg')}
                  >
                    <div className="flex items-center gap-3 flex-1">
                      <div 
                        className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 transition-all"
                        style={{
                          backgroundColor: meal.nonVeg ? '#EF4444' : 'transparent',
                          border: `2px solid ${meal.nonVeg ? '#EF4444' : colors.border}`
                        }}
                      >
                        {meal.nonVeg && <FaCheck className="text-white text-[10px]" />}
                      </div>
                      <span className="text-sm font-medium" style={{ color: colors.text }}>
                        <FaFish className="inline mr-1.5 text-red-500" /> Non-Veg
                      </span>
                    </div>
                    {meal.nonVeg ? (
                      <div className="flex items-center gap-2 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                        <button 
                          className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                          style={{ backgroundColor: '#EF4444', color: 'white' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            updateCustomMealQty(mealTime, 'nonVeg', -1);
                          }}
                        >
                          <FaMinus className="text-[10px]" />
                        </button>
                        <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
                          {meal.nonVegQty}
                        </span>
                        <button 
                          className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                          style={{ backgroundColor: '#22C55E', color: 'white' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            updateCustomMealQty(mealTime, 'nonVeg', 1);
                          }}
                        >
                          <FaPlus className="text-[10px]" />
                        </button>
                        <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
                          ₹{price * meal.nonVegQty}
                        </span>
                      </div>
                    ) : (
                      <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
                    )}
                  </div>

                  {/* Summary */}
                  <div className="mt-3 pt-3 border-t text-sm" style={{ borderColor: colors.border }}>
                    {hasSelection ? (
                      <>
                        {meal.veg && meal.nonVeg && (
                          <span style={{ color: colors.textSecondary }}>✅ Veg & Non-Veg selected</span>
                        )}
                        {meal.veg && !meal.nonVeg && (
                          <span style={{ color: '#22C55E' }}>✅ Veg selected ({meal.vegQty})</span>
                        )}
                        {!meal.veg && meal.nonVeg && (
                          <span style={{ color: '#EF4444' }}>✅ Non-Veg selected ({meal.nonVegQty})</span>
                        )}
                      </>
                    ) : (
                      <span style={{ color: colors.textSecondary }}>❌ No meals selected</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 mt-6">
            <button
              className="flex-1 py-3 rounded-xl text-sm font-medium transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
              style={{ 
                backgroundColor: '#EF444420',
                color: '#EF4444',
                border: `1px solid #EF444430`
              }}
              onClick={handleClearDateMeals}
            >
              <FaEraser className="text-sm" /> Clear Plan
            </button>
            <button
              className="flex-1 py-3 rounded-xl text-sm font-medium text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
              style={{ 
                backgroundColor: colors.primary,
                boxShadow: `0 4px 20px ${colors.primary}40`
              }}
              onClick={handleSaveDateMeals}
              disabled={!Object.values(dateMealSelections).some(m => m.veg || m.nonVeg)}
            >
              <FaSave className="text-sm" /> Save Details
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ========== MONTHLY MEAL SELECTION (FIXED - Using stable IDs) ==========
  const renderMonthlyMealSelection = () => {
    console.log('Rendering monthly meal selection with mealItems:', mealItems);
    
    return mealItems.map((meal, index) => {
      const hasSelection = meal.veg.selected || meal.nonVeg.selected;
      // Use stable IDs based on index and meal_time
      const vegId = `veg-${index}-${meal.meal_time}`;
      const nonVegId = `nonVeg-${index}-${meal.meal_time}`;
      
      return (
        <div 
          key={index} 
          className="rounded-xl p-4 mb-4" 
          style={{ 
            backgroundColor: colors.card, 
            border: `1px solid ${colors.border}`
          }}
        >
          <div className="flex items-center justify-between mb-3">
            <div>
              <h4 className="font-bold text-lg" style={{ color: colors.text }}>{meal.meal_time}</h4>
              <p className="text-xs" style={{ color: colors.textSecondary }}>
                <FaClock className="inline mr-1 text-[10px]" /> {meal.time_slot}
              </p>
            </div>
            <div className="text-xs px-2 py-1 rounded-full" style={{ 
              backgroundColor: colors.primary + '20',
              color: colors.primary
            }}>
              {hasSelection ? `${getTotalItems()} meal selected` : 'Select Veg and/or Non-Veg'}
            </div>
          </div>

          {/* Veg Option */}
          <div 
            className="flex items-center justify-between p-3 rounded-xl transition-all mb-2"
            style={{ 
              backgroundColor: meal.veg.selected ? '#22C55E08' : colors.inputBackground,
              border: `2px solid ${meal.veg.selected ? '#22C55E' : colors.border}`,
            }}
          >
            <label 
              htmlFor={vegId}
              className="flex items-center gap-3 flex-1"
              style={{ 
                cursor: 'pointer', 
                display: 'flex', 
                alignItems: 'center',
                userSelect: 'none'
              }}
            >
              <input
                type="checkbox"
                id={vegId}
                checked={meal.veg.selected}
                onChange={(e) => {
                  e.stopPropagation();
                  console.log('🔄 Veg checkbox onChange for index:', index, 'checked:', e.target.checked);
                  toggleVeg(index);
                }}
                style={{
                  width: '20px',
                  height: '20px',
                  accentColor: '#22C55E',
                  cursor: 'pointer',
                  flexShrink: 0,
                  pointerEvents: 'auto',
                  zIndex: 10,
                  position: 'relative'
                }}
                className="w-5 h-5 rounded border-2 transition-all cursor-pointer"
              />
              <span className="text-sm font-medium" style={{ color: colors.text }}>
                <FaLeaf className="inline mr-1.5 text-green-500" /> Veg
              </span>
            </label>
            
            {meal.veg.selected ? (
              <div className="flex items-center gap-2 flex-shrink-0">
                <button 
                  className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                  style={{ backgroundColor: '#EF4444', color: 'white', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    updateVegQuantity(index, -1);
                  }}
                >
                  <FaMinus className="text-[10px]" />
                </button>
                <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
                  {meal.veg.quantity}
                </span>
                <button 
                  className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                  style={{ backgroundColor: '#22C55E', color: 'white', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    updateVegQuantity(index, 1);
                  }}
                >
                  <FaPlus className="text-[10px]" />
                </button>
                <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
                  ₹{mealPrices[meal.meal_time] * meal.veg.quantity}
                </span>
              </div>
            ) : (
              <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
            )}
          </div>

          {/* Non-Veg Option */}
          <div 
            className="flex items-center justify-between p-3 rounded-xl transition-all"
            style={{ 
              backgroundColor: meal.nonVeg.selected ? '#EF444408' : colors.inputBackground,
              border: `2px solid ${meal.nonVeg.selected ? '#EF4444' : colors.border}`,
            }}
          >
            <label 
              htmlFor={nonVegId}
              className="flex items-center gap-3 flex-1"
              style={{ 
                cursor: 'pointer', 
                display: 'flex', 
                alignItems: 'center',
                userSelect: 'none'
              }}
            >
              <input
                type="checkbox"
                id={nonVegId}
                checked={meal.nonVeg.selected}
                onChange={(e) => {
                  e.stopPropagation();
                  console.log('🔄 Non-Veg checkbox onChange for index:', index, 'checked:', e.target.checked);
                  toggleNonVeg(index);
                }}
                style={{
                  width: '20px',
                  height: '20px',
                  accentColor: '#EF4444',
                  cursor: 'pointer',
                  flexShrink: 0,
                  pointerEvents: 'auto',
                  zIndex: 10,
                  position: 'relative'
                }}
                className="w-5 h-5 rounded border-2 transition-all cursor-pointer"
              />
              <span className="text-sm font-medium" style={{ color: colors.text }}>
                <FaFish className="inline mr-1.5 text-red-500" /> Non-Veg
              </span>
            </label>
            
            {meal.nonVeg.selected ? (
              <div className="flex items-center gap-2 flex-shrink-0">
                <button 
                  className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                  style={{ backgroundColor: '#EF4444', color: 'white', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    updateNonVegQuantity(index, -1);
                  }}
                >
                  <FaMinus className="text-[10px]" />
                </button>
                <span className="font-bold min-w-[20px] text-center text-sm" style={{ color: colors.text }}>
                  {meal.nonVeg.quantity}
                </span>
                <button 
                  className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-105"
                  style={{ backgroundColor: '#22C55E', color: 'white', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    updateNonVegQuantity(index, 1);
                  }}
                >
                  <FaPlus className="text-[10px]" />
                </button>
                <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
                  ₹{mealPrices[meal.meal_time] * meal.nonVeg.quantity}
                </span>
              </div>
            ) : (
              <span className="text-xs flex-shrink-0" style={{ color: colors.textSecondary }}>Not selected</span>
            )}
          </div>
          
          <div className="mt-3 pt-3 border-t text-sm" style={{ borderColor: colors.border }}>
            {hasSelection ? (
              <>
                {meal.veg.selected && meal.nonVeg.selected && (
                  <span style={{ color: colors.textSecondary }}>✅ Veg & Non-Veg selected</span>
                )}
                {meal.veg.selected && !meal.nonVeg.selected && (
                  <span style={{ color: '#22C55E' }}>✅ Veg selected ({meal.veg.quantity})</span>
                )}
                {!meal.veg.selected && meal.nonVeg.selected && (
                  <span style={{ color: '#EF4444' }}>✅ Non-Veg selected ({meal.nonVeg.quantity})</span>
                )}
              </>
            ) : (
              <span style={{ color: colors.textSecondary }}>❌ No meals selected</span>
            )}
          </div>
        </div>
      );
    });
  };

  // ========== MAIN RENDER ==========
  const token = localStorage.getItem('token');
  
  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center" 
           style={{ backgroundColor: colors.background }}>
        <div className="text-center p-8 rounded-2xl max-w-md w-full"
             style={{ 
               backgroundColor: colors.card,
               border: `1px solid ${colors.border}`
             }}>
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 mx-auto" style={{ borderColor: colors.primary }}></div>
          <p className="mt-4 font-medium" style={{ color: colors.textSecondary }}>
            Please login to continue...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full flex flex-col" style={{ backgroundColor: colors.background }}>
      {/* Login Modal */}
      <LoginModal 
        isOpen={showLoginModal} 
        onClose={() => dispatch(setShowLoginModal(false))} 
      />

      {/* Full Screen Hero */}
      <div className="fixed inset-0 w-full h-full flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1920&h=1080&fit=crop)', backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-black/70 via-black/50 to-black/80" />
        
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white w-full px-4 sm:px-6 lg:px-8">
          <div className="inline-flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm border border-yellow-400/30 px-5 py-2 rounded-full text-sm font-medium text-yellow-200 mb-6">
            <FaFire className="text-yellow-400" /> Fresh & Homemade
          </div>
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-3 leading-tight">Tiffin Service</h1>
          <p className="text-2xl sm:text-3xl md:text-4xl text-yellow-300 font-semibold mb-4">Dil Se Plate Tak ❤️</p>
          <p className="text-base sm:text-lg text-white/90 max-w-2xl mx-auto mb-8">Ghar jaisa swaad, har dabbe ke saath. Fresh, homemade meals delivered daily.</p>

          <div className="flex flex-wrap items-center justify-center gap-6 mb-8 text-sm text-white/70">
            <span className="flex items-center gap-2"><FaClock className="text-yellow-400" /> Breakfast 7:30-10 AM</span>
            <span className="w-px h-4 bg-white/20 hidden sm:block"></span>
            <span className="flex items-center gap-2"><FaClock className="text-yellow-400" /> Lunch 12-2:30 PM</span>
            <span className="w-px h-4 bg-white/20 hidden sm:block"></span>
            <span className="flex items-center gap-2"><FaClock className="text-yellow-400" /> Dinner 7:30-10 PM</span>
          </div>

          <button 
            className="px-10 py-4 rounded-full text-white font-semibold text-lg shadow-2xl flex items-center gap-3 mx-auto transition-all hover:scale-105 active:scale-95" 
            style={{ background: 'linear-gradient(135deg, #FD8A36, #E07324)', boxShadow: '0 8px 40px rgba(253, 138, 54, 0.4)' }} 
            onClick={handleBookNow}
          >
            <FaCalendarCheck className="text-xl" /> Book Now <FaArrowRight className="text-sm" />
          </button>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-6 text-sm text-white/60">
            <span className="flex items-center gap-2"><FaUtensils className="text-yellow-400" /> 42+ Dishes</span>
            <span className="text-white/20">•</span>
            <span className="flex items-center gap-2"><FaLeaf className="text-green-400" /> Veg & Non-Veg</span>
            <span className="text-white/20">•</span>
            <span className="flex items-center gap-2"><FaTruck className="text-blue-400" /> Free Delivery</span>
          </div>
        </div>
      </div>

      {/* ========== BOOKING MODAL ========== */}
      {/* ========== BOOKING MODAL ========== */}
{/* ========== BOOKING MODAL ========== */}
{showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center px-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }} onClick={() => setShowModal(false)}>
    <div className="rounded-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }} onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-2xl font-bold" style={{ color: colors.text }}>Tiffin Express</h3>
          <p className="text-sm" style={{ color: colors.textSecondary }}>Dil Se Plate Tak ❤️</p>
        </div>
        <button 
          className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" 
          style={{ backgroundColor: colors.inputBackground }} 
          onClick={() => setShowModal(false)}
        >
          <FaTimes style={{ color: colors.text }} />
        </button>
      </div>

      {/* Weekly Menu Section */}
      <div className="mb-4 p-3 rounded-xl" style={{ 
        backgroundColor: colors.primary + '10', 
        border: `1px solid ${colors.primary}25` 
      }}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <FaCalendarWeek className="text-sm" style={{ color: colors.primary }} />
            <p className="text-sm font-bold" style={{ color: colors.text }}>
              Weekly Menu
            </p>
          </div>
          <span className="text-[8px] px-2 py-0.5 rounded-full" style={{ 
            backgroundColor: colors.primary + '20',
            color: colors.primary
          }}>
            {weeklyMenu.length} items
          </span>
        </div>
        {renderWeeklyMenuInModal()}
      </div>

      {/* View Mode Toggle */}
      <div className="flex gap-2 mb-6 bg-gray-100 dark:bg-gray-800 rounded-xl p-1">
        <button 
          className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${viewMode === 'monthly' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'bg-transparent'}`} 
          style={{ color: viewMode === 'monthly' ? colors.primary : colors.textSecondary, boxShadow: viewMode === 'monthly' ? '0 2px 8px rgba(0,0,0,0.08)' : 'none' }} 
          onClick={() => setViewMode('monthly')}
        >
          <FaCalendarWeek className="text-xs" /> Monthly Tiffin
        </button>
        <button 
          className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${viewMode === 'custom' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'bg-transparent'}`} 
          style={{ color: viewMode === 'custom' ? colors.primary : colors.textSecondary, boxShadow: viewMode === 'custom' ? '0 2px 8px rgba(0,0,0,0.08)' : 'none' }} 
          onClick={() => setViewMode('custom')}
        >
          <FaCalendarDay className="text-xs" /> Custom Date
        </button>
      </div>

      {/* ========== MONTHLY TIFFIN VIEW ========== */}
      {viewMode === 'monthly' && (
        <div className="space-y-4">
          {/* Show active tiffin warning if exists */}
          {displayError?.includes('active') && selectedSubscriptionId ? (
            <div className="text-center py-6">
              <div className="text-5xl mb-4">⚠️</div>
              <h4 className="text-lg font-bold mb-2" style={{ color: colors.text }}>Active Tiffin Found</h4>
              <p className="text-sm mb-4" style={{ color: colors.textSecondary }}>
                You already have an active tiffin (ID: {selectedSubscriptionId}). 
                Please cancel it first to create a new one.
              </p>
              <button 
                onClick={handleCancelSubscription} 
                className="px-6 py-2.5 rounded-xl text-white font-medium transition-all hover:scale-105 flex items-center justify-center gap-2 mx-auto" 
                style={{ backgroundColor: '#EF4444' }}
                disabled={localError?.includes('already cancelled')}
              >
                <FaTrash className="text-sm" /> Cancel Tiffin
              </button>
              {localError?.includes('already cancelled') && (
                <p className="text-xs mt-2" style={{ color: colors.textSecondary }}>
                  This tiffin has already been cancelled.
                </p>
              )}
            </div>
          ) : (
            /* Show monthly tiffin form only if no active tiffin */
            <>
              <div className="p-3 rounded-xl" style={{ backgroundColor: colors.primary + '10', border: `1px solid ${colors.primary}25` }}>
                <p className="text-sm font-medium flex items-center gap-2" style={{ color: colors.primary }}>
                  <FaInfoCircle className="text-xs" /> Monthly Tiffin Plan
                </p>
                <p className="text-xs" style={{ color: colors.textSecondary }}>Configure your regular daily default meals and selected start date.</p>
              </div>

              <div>
                <label className="text-sm font-medium block mb-1.5" style={{ color: colors.textSecondary }}>📅 Start Date</label>
                <div className="flex items-center justify-between p-3 rounded-xl cursor-pointer hover:shadow-md transition-all" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }} onClick={() => setShowCalendar(!showCalendar)}>
                  <span className="text-sm font-medium" style={{ color: colors.text }}>{formatDate(subscriptionStartDate)}</span>
                  <FaCalendarAlt style={{ color: colors.primary }} />
                </div>
{showCalendar && (
  <div 
    className={`mt-2 p-3 rounded-xl`}
    style={{ 
      backgroundColor: colors.card, 
      border: `1px solid ${colors.border}` 
    }}
  >
    {/* Step 2: Add inline dark mode styles */}
    {isDark && (
      <style>
        {`
          /* Calendar container */
          .react-calendar {
            background-color: #1a1a2e !important;
            border-color: #2d3436 !important;
            color: #ffffff !important;
            border-radius: 12px !important;
            padding: 12px !important;
            width: 100% !important;
            border: none !important;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
          }
          
          /* Navigation (month/year header) */
          .react-calendar__navigation {
            background-color: #1a1a2e !important;
            margin-bottom: 8px !important;
          }
          
          .react-calendar__navigation button {
            color: #ffffff !important;
            background: transparent !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            padding: 8px 12px !important;
            border-radius: 8px !important;
          }
          
          .react-calendar__navigation button:hover {
            background-color: #2d3436 !important;
          }
          
          .react-calendar__navigation__label {
            color: #ffffff !important;
          }
          
          /* Weekday headers */
          .react-calendar__month-view__weekdays {
            color: #8888aa !important;
            text-transform: uppercase !important;
            font-size: 10px !important;
            font-weight: 600 !important;
          }
          
          .react-calendar__month-view__weekdays__weekday {
            color: #8888aa !important;
            padding: 6px 0 !important;
          }
          
          .react-calendar__month-view__weekdays__weekday abbr {
            text-decoration: none !important;
            color: #8888aa !important;
            cursor: default !important;
          }
          
          /* Day tiles (dates) */
          .react-calendar__tile {
            background-color: transparent !important;
            color: #ffffff !important;
            padding: 10px 6px !important;
            border-radius: 8px !important;
            font-size: 14px !important;
            transition: all 0.2s ease !important;
          }
          
          .react-calendar__tile:hover {
            background-color: #2d3436 !important;
            transform: scale(1.05) !important;
          }
          
          /* Today's date */
          .react-calendar__tile--now {
            background-color: #2d3436 !important;
            border-radius: 8px !important;
            font-weight: 600 !important;
          }
          
          .react-calendar__tile--now:hover {
            background-color: #3d3d5c !important;
          }
          
          /* Selected date */
          .react-calendar__tile--active {
            background: linear-gradient(135deg, #FD8A36, #E07324) !important;
            border-radius: 8px !important;
            color: #ffffff !important;
            font-weight: 600 !important;
            box-shadow: 0 4px 15px rgba(253, 138, 54, 0.3) !important;
          }
          
          .react-calendar__tile--active:hover {
            background: linear-gradient(135deg, #E07324, #CC6620) !important;
          }
          
          /* Weekend dates */
          .react-calendar__month-view__days__day--weekend {
            color: #ff6b6b !important;
          }
          
          /* Dates from other months */
          .react-calendar__month-view__days__day--neighboringMonth {
            color: #555577 !important;
            opacity: 0.6 !important;
          }
          
          /* Disabled dates */
          .react-calendar__tile:disabled {
            background-color: transparent !important;
            color: #555577 !important;
            opacity: 0.4 !important;
            cursor: not-allowed !important;
          }
        `}
      </style>
    )}
    
    {/* Step 3: The Calendar component */}
    <Calendar 
      onChange={(date) => { 
        setSubscriptionStartDate(date); 
        setShowCalendar(false); 
      }} 
      value={subscriptionStartDate} 
      minDate={new Date()} 
      className="w-full"
    />
  </div>
)}
              </div>

              <div>
                <label className="text-sm font-medium block mb-1.5" style={{ color: colors.textSecondary }}>
                  📍 Delivery Address <span className="text-xs" style={{ color: colors.textSecondary }}>(Required)</span>
                </label>
                <input
                  type="text"
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                  placeholder="Enter your delivery address"
                  className="w-full p-3 rounded-xl focus:outline-none"
                  style={{ 
                    backgroundColor: colors.inputBackground, 
                    border: `1px solid ${colors.border}`, 
                    color: colors.text 
                  }}
                />
                <p className="text-xs mt-1" style={{ color: colors.primary }}>
                  📍 This address will be automatically saved to your profile
                </p>
              </div>

              <div>
                <label className="text-sm font-medium block mb-2" style={{ color: colors.textSecondary }}>
                  Select Meals
                </label>
                {renderMonthlyMealSelection()}
              </div>

              <button 
                className="w-full py-3.5 rounded-xl font-semibold text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2 disabled:opacity-50" 
                style={{ 
                  backgroundColor: getTotalItems() > 0 && deliveryAddress.trim() ? colors.primary : '#9CA3AF', 
                  boxShadow: getTotalItems() > 0 && deliveryAddress.trim() ? `0 4px 20px ${colors.primary}40` : 'none',
                  opacity: getTotalItems() > 0 && deliveryAddress.trim() ? 1 : 0.5,
                  cursor: getTotalItems() > 0 && deliveryAddress.trim() ? 'pointer' : 'not-allowed'
                }} 
                onClick={handleCreateSubscription}
                disabled={isSubscribing || getTotalItems() === 0 || !deliveryAddress.trim()}
              >
                {isSubscribing ? (
                  <><FaSpinner className="animate-spin" /> Creating Tiffin...</>
                ) : (
                  <><FaCalendarAlt className="inline mr-2" /> Confirm Tiffin</>
                )}
              </button>

              {getTotalItems() === 0 && (
                <p className="text-center text-xs mt-2" style={{ color: colors.textSecondary }}>
                  Please select at least one meal (Veg or Non-Veg)
                </p>
              )}
              {deliveryAddress.trim() === '' && getTotalItems() > 0 && (
                <p className="text-center text-xs mt-2" style={{ color: colors.textSecondary }}>
                  Please enter delivery address
                </p>
              )}
            </>
          )}
        </div>
      )}

      {/* ========== CUSTOM DATE VIEW - ONLY CUSTOM DATE CONTENT ========== */}
      {viewMode === 'custom' && (
        <div className="space-y-4">
          <div className="p-3 rounded-xl" style={{ backgroundColor: colors.primary + '10', border: `1px solid ${colors.primary}25` }}>
            <p className="text-sm font-medium flex items-center gap-2" style={{ color: colors.primary }}>
              <FaInfoCircle className="text-xs" /> Custom Date Order
            </p>
            <p className="text-xs" style={{ color: colors.textSecondary }}>
              Click on any date to select meals for that specific day
            </p>
          </div>

          <div>
            <label className="text-sm font-medium block mb-1.5" style={{ color: colors.textSecondary }}>
              📍 Delivery Address <span className="text-xs" style={{ color: colors.textSecondary }}>(Required)</span>
            </label>
            <input
              type="text"
              value={customDeliveryAddress}
              onChange={(e) => setCustomDeliveryAddress(e.target.value)}
              placeholder="Enter your delivery address"
              className="w-full p-3 rounded-xl focus:outline-none"
              style={{ 
                backgroundColor: colors.inputBackground, 
                border: `1px solid ${colors.border}`, 
                color: colors.text 
              }}
            />
            <p className="text-xs mt-1" style={{ color: colors.primary }}>
              📍 This address will be automatically saved to your profile
            </p>
          </div>

          {/* Calendar with clickable dates */}
          <div className="rounded-xl p-4" style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}` }}>
            {renderCalendar()}
          </div>

          {/* Date Meal Selection Modal - Opens when clicking a date */}
          <DateMealModal />

          {/* Selected Entries Summary */}
          {customBookingEntries.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="text-sm font-medium" style={{ color: colors.textSecondary }}>
                  Selected Meals ({customBookingEntries.length})
                </label>
                <button
                  className="text-xs font-medium transition-all hover:scale-105 flex items-center gap-1"
                  style={{ color: '#EF4444' }}
                  onClick={handleClearAllEntries}
                >
                  <FaEraser className="text-[10px]" /> Clear All
                </button>
              </div>
              <div className="space-y-2 max-h-40 overflow-y-auto">
                {customBookingEntries.map((entry, index) => {
                  const mealColors = { 'Breakfast': '#F59E0B', 'Lunch': '#F97316', 'Dinner': '#6366F1' };
                  const price = mealPrices[entry.meal_time] || 60;
                  return (
                    <div key={index} className="flex items-center justify-between p-2.5 rounded-lg" style={{ backgroundColor: colors.inputBackground, border: `1px solid ${colors.border}` }}>
                      <div className="text-xs">
                        <span className="font-semibold" style={{ color: colors.text }}>{formatDate(new Date(entry.date))}</span>
                        <span className="ml-2" style={{ color: mealColors[entry.meal_time] }}>{entry.meal_time}</span>
                        <span className="ml-2" style={{ color: colors.primary }}>×{entry.quantity}</span>
                        <span className="ml-2 text-[8px]" style={{ color: colors.textSecondary }}>₹{price * entry.quantity}</span>
                      </div>
                      <button
                        className="w-8 h-8 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95"
                        style={{ backgroundColor: '#EF444420', color: '#EF4444' }}
                        onClick={() => handleRemoveEntry(index)}
                      >
                        <FaTrash className="text-xs" />
                      </button>
                    </div>
                  );
                })}
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="text-sm font-bold" style={{ color: colors.primary }}>
                  Total: ₹{getTotalCustomPrice()}
                </div>
              </div>
            </div>
          )}

          <button
            className="w-full py-3.5 rounded-xl font-semibold text-white transition-all hover:scale-[1.02] flex items-center justify-center gap-2"
            style={{
              backgroundColor: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? colors.primary : '#9CA3AF',
              boxShadow: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? `0 4px 20px ${colors.primary}40` : 'none',
              opacity: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? 1 : 0.5,
              cursor: customBookingEntries.length > 0 && customDeliveryAddress.trim() ? 'pointer' : 'not-allowed'
            }}
            onClick={handleCustomDateOrder}
            disabled={isLoading || customBookingEntries.length === 0 || !customDeliveryAddress.trim()}
          >
            {isLoading ? (
              <><FaSpinner className="animate-spin" /> Processing...</>
            ) : (
              <><FaCalendarCheck /> Confirm Custom Order</>
            )}
          </button>
          {!customDeliveryAddress.trim() && customBookingEntries.length > 0 && (
            <p className="text-center text-xs mt-2" style={{ color: colors.textSecondary }}>
              Please enter delivery address to confirm order
            </p>
          )}
        </div>
      )}

      <p className="text-xs text-center mt-4" style={{ color: colors.textSecondary + '80' }}>By booking, you agree to our Terms of Service</p>
    </div>
  </div>
)}
    </div>
  );
};
export default TiffinService;  